<template>
  <div class="addSupplierDelivery">
    <el-form
      label-width="120px"
      :model="formInline"
      :rules="formInlineRules"
      ref="formInline"
      :validate-on-rule-change="false"
      :disabled="detailDisable"
    >
      <div class="topFrom" ref="sub">
        <el-row>
          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.shippingInstruction')"
              prop="instructionNo"
            >
              <el-input v-model="formInline.instructionNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.createData')"
              prop="instructionCreateDate"
            >
              <el-date-picker
                class="inputWidth"
                disabled
                v-model="formInline.instructionCreateDate"
                type="date"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发货指令状态" prop="instructionStatus">
              <el-select class="inputWidth" v-model="formInline.instructionStatus" disabled>
                <el-option :label="$t('addSupplierDelivery.option.save')" value="0"></el-option>
                <el-option label="已业务入库" value="1"></el-option>
                <!-- <el-option :label="$t('addSupplierDelivery.option.toStore')" value="2"></el-option> -->
                <el-option :label="$t('addSupplierDelivery.option.cancel')" value="3"></el-option>
                <el-option label="已冲销" value="4"></el-option>
                <el-option label="部分冲销" value="5"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.createPersonName')"
              prop="instructionCreatePersonName"
            >
              <el-input v-model="formInline.instructionCreatePersonName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.companyName')"
              prop="instructionCompanyName"
            >
              <el-input v-model="formInline.instructionCompanyName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务入库单号">
              <el-input v-model="formInline.businessInboundNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.instructionType')"
              prop="instructionType"
            >
              <el-select
                class="inputWidth"
                v-model="formInline.instructionType"
                @change="instructionTypeChange"
              >
                <el-option
                  v-for="(item, index) in instuctionTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.isDirectDeliver')"
              prop="directDeliver"
            >
              <el-select class="inputWidth" v-model="formInline.directDeliver" disabled>
                <el-option :label="$t('addSupplierDelivery.option.direct')" value="1"></el-option>
                <el-option
                  :label="$t('addSupplierDelivery.option.notDirect')"
                  value="0"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('addSupplierDelivery.detail.deliverMethod')"
              prop="deliverMethod"
            >
              <el-select class="inputWidth" v-model="formInline.deliverMethod" disabled>
                <el-option
                  :label="$t('addSupplierDelivery.option.supplierSend')"
                  value="0"
                ></el-option>
                <el-option
                  :label="$t('addSupplierDelivery.option.selfProduction')"
                  value="1"
                ></el-option>
                <el-option
                  :label="$t('addSupplierDelivery.option.selfCustomer')"
                  value="2"
                ></el-option>
                <el-option
                  :label="$t('addSupplierDelivery.option.libraryTurn')"
                  value="3"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
      </div>
    </el-form>

    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <el-form
            :model="formBaseInfo"
            label-width="120px"
            ref="formBaseInfo"
            :rules="formBaseInfoRules"
            :validate-on-rule-change="false"
            :disabled="detailDisable"
          >
            <el-row :gutter="10">
              <el-col :span="6">
                <!-- 供应商 -->
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.partnerNo')"
                  prop="partnerName"
                >
                  <!-- 弹窗搜索 -->
                  <search-table
                    v-model="formBaseInfo.partnerNo"
                    searchType="supplier"
                    v-if="formBaseInfo.contractDetailCategory == 'HT04'"
                    :isMultiple="true"
                    :disabled="true"
                    :currentValue="formBaseInfo.partnerName ? formBaseInfo.partnerName : ''"
                    :checkRowKeys="formBaseInfo.partnerNo ? [formBaseInfo.partnerNo] : []"
                    @input="(val) => chooseForm(val, 'partnerNo')"
                  ></search-table>
                  <el-input v-else v-model="formBaseInfo.partnerName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.departmentNo')"
                  prop="instructionDepartmentName"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="formBaseInfo.instructionDepartmentName"
                    placement="top"
                    :disabled="!formBaseInfo.instructionDepartmentName"
                  >
                    <el-input v-model="formBaseInfo.instructionDepartmentName" disabled></el-input>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 业务员 -->
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.salesmanNo')"
                  prop="salesmanNo"
                >
                  <!--弹窗搜索-->
                  <search-table
                    v-model="formBaseInfo.salesmanNo"
                    searchType="personnel"
                    :isMultiple="true"
                    :disabled="showStatus === '1'"
                    :currentValue="formBaseInfo.salesmanName ? formBaseInfo.salesmanName : ''"
                    :checkRowKeys="formBaseInfo.salesmanNo ? [formBaseInfo.salesmanNo] : []"
                    @input="(val) => chooseForm(val, 'salesmanNo')"
                  ></search-table>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 业务员 -->
                <el-form-item label="项目简称" prop="projectInitiationNo">
                  <SearchTable
                    v-model="formBaseInfo.projectInitiationNo"
                    searchType="projectList1"
                    :isMultiple="true"
                    :disabled="isOutLink && formBaseInfo.projectInitiationNo"
                    :currentValue="formBaseInfo.projectName ? formBaseInfo.projectName : ''"
                    :checkRowKeys="
                      formBaseInfo.projectInitiationNo ? [formBaseInfo.projectInitiationNo] : []
                    "
                    :extraData="{
                      // applyDepartmentNo: userInfo.departmentCode,
                      // applyDepartmentName: userInfo.departmentName,
                    }"
                    @input="(val) => chooseForm(val, 'projectInitiationNo')"
                  ></SearchTable>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!isChengKuang">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.deliverFromStorageNo')"
                  prop="deliverFromStorageNo"
                >
                  <!--弹窗搜索-->
                  <search-table
                    v-model="formBaseInfo.deliverFromStorageNo"
                    searchType="warehouse"
                    :isMultiple="true"
                    :disabled="showStatus === '1'"
                    :currentValue="
                      formBaseInfo.deliverFromStorageName ? formBaseInfo.deliverFromStorageName : ''
                    "
                    :checkRowKeys="
                      formBaseInfo.deliverFromStorageNo ? [formBaseInfo.deliverFromStorageNo] : []
                    "
                    :extraData="{
                      adminFlag: this.userInfo.adminFlag,
                      currentStatus: 'ZT03', //已生效的仓库
                      storageDepartmentCode: this.userInfo.departmentCode,
                      storageCompanyCode: this.userInfo.companyCode,
                    }"
                    @input="(val) => chooseForm(val, 'deliverFromStorageNo')"
                  ></search-table>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!isChengKuang">
                <el-form-item :label="$t('addSupplierDelivery.detail.deliverFromAddress')">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="formBaseInfo.deliverFromAddress"
                    placement="top"
                    :disabled="!formBaseInfo.deliverFromAddress"
                  >
                    <el-input
                      v-model="formBaseInfo.deliverFromAddress"
                      clearable
                      maxlength="32"
                    ></el-input>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.purchaseContractNo')"
                  prop="purchaseContractNo"
                >
                  <el-input v-model="formBaseInfo.purchaseContractNo" disabled></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.purchaseIntentNo')"
                  prop="purchaseIntentNo"
                >
                  <el-input v-model="formBaseInfo.purchaseIntentNo" disabled></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.deliverDate')"
                  prop="deliverDate"
                >
                  <el-date-picker
                    class="inputWidth"
                    v-model="formBaseInfo.deliverDate"
                    type="date"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!isChengKuang">
                <el-form-item :label="$t('addSupplierDelivery.detail.insured')" prop="insured">
                  <el-select class="inputWidth" v-model="formBaseInfo.insured" clearable filterable>
                    <el-option
                      :label="$t('addSupplierDelivery.detail.insuredOptionOne')"
                      :value="1"
                    ></el-option>
                    <el-option
                      :label="$t('addSupplierDelivery.detail.insuredOptionTwo')"
                      :value="0"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!isChengKuang">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.expectArrivalDate')"
                  prop="expectArrivalDate"
                >
                  <el-date-picker
                    clearable
                    class="inputWidth"
                    v-model="formBaseInfo.expectArrivalDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :placeholder="$t('addSupplierDelivery.detail.chooseExpectArrivalDate')"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.deliverToStorageNo')"
                  prop="deliverToStorageNo"
                >
                  <search-table
                    v-model="formBaseInfo.deliverToStorageNo"
                    searchType="warehouseDirectDeliver"
                    v-if="!formBaseInfo.flowDirection"
                    :isMultiple="true"
                    :disabled="showStatus === '1'"
                    :extraData="{
                      adminFlag: this.userInfo.adminFlag,
                      currentStatus: 'ZT03', //已生效的仓库
                      storageDepartmentCode: this.userInfo.departmentCode,
                      storageCompanyCode: this.userInfo.companyCode,
                    }"
                    :currentValue="
                      formBaseInfo.deliverToStorageName ? formBaseInfo.deliverToStorageName : ''
                    "
                    :checkRowKeys="
                      formBaseInfo.deliverToStorageNo ? [formBaseInfo.deliverToStorageNo] : []
                    "
                    @input="(val) => chooseForm(val, 'deliverToStorageNo')"
                  ></search-table>
                  <el-input v-else disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.externalContractNo')"
                  prop="externalContractNo"
                >
                  <el-input v-model="formBaseInfo.externalContractNo" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!isChengKuang">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.shippingContact')"
                  prop="shippingContact"
                >
                  <el-input
                    v-model="formBaseInfo.shippingContact"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!isChengKuang">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.shippingContactPerson')"
                  prop="shippingContactPerson"
                >
                  <el-input
                    v-model="formBaseInfo.shippingContactPerson"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.flowDirection')"
                  prop="flowDirection"
                >
                  <el-input
                    v-model="formBaseInfo.flowDirection"
                    :disabled="formBaseInfo.deliverToStorageNo ? true : false"
                    @input="changeFlowDirection"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="6" v-if="!isChengKuang">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.businessMode')"
                  prop="businessMode"
                >
                  <ajax-select
                    v-model="formBaseInfo.businessMode"
                    :apiUrl="dictApi"
                    :apiData="operationModeData"
                  ></ajax-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!isChengKuang">
                <el-form-item label="货币" prop="currencyTypeCode">
                  <ajax-select
                    v-model="formBaseInfo.currencyTypeCode"
                    :apiUrl="currencyApi"
                    :apiData="currencyData"
                    :disabled="true"
                    valueKey="currencyCode"
                    moreShowKey="currencyCode"
                    labelKey="currencyName"
                    method="get"
                  ></ajax-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!isChengKuang">
                <el-form-item label="业务入库日期" prop="inboundDate">
                  <el-date-picker
                    class="inputWidth"
                    v-model="formBaseInfo.inboundDate"
                    type="date"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!isChengKuang">
                <el-form-item label="平台公司" prop="platformCompanyCode">
                  <el-select
                    class="inputWidth"
                    v-model="formBaseInfo.platformCompanyCode"
                    clearable
                    filterable
                    @change="handlePlatformChange"
                  >
                    <el-option
                      v-for="(item, index) in platformCompanyList"
                      :key="index"
                      :label="item.personCompanyName"
                      :value="item.personCompanyCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="基地简称" prop="baseName">
                  <el-select
                    class="inputWidth"
                    v-model="formBaseInfo.baseName"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="(item, index) in baseNameList"
                      :key="index"
                      :label="item.addressAbbreviation"
                      :value="item.addressAbbreviation"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="运输方式" prop="shipingMethod">
                  <el-input
                    v-model="formBaseInfo.shipingMethod"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-row>
              <el-col :span="6">
                <el-form-item label="货币" prop="currencyTypeCode">
                  <ajax-select
                    v-model="formBaseInfo.currencyTypeCode"
                    :apiUrl="currencyApi"
                    :apiData="currencyData"
                    :disabled="true"
                    valueKey="currencyCode"
                    moreShowKey="currencyCode"
                    labelKey="currencyName"
                    method="get"
                  ></ajax-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="业务入库日期" prop="inboundDate">
                  <el-date-picker
                    class="inputWidth"
                    v-model="formBaseInfo.inboundDate"
                    type="date"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="referenceContractNo" label="关联合同号">
                  <SearchModal
                    ref="searchModal"
                    propName="contractNo"
                    propCode="contractNo"
                    model="formBaseInfo.referenceContractNo"
                    :placeholder="this.$t('applicationCredit.form.referenceContractNoPlaceholder')"
                    :API="referenceContract.API"
                    :page="true"
                    :columnList="referenceContract.columnList"
                    :extraData="referenceContract.extraData"
                    :isMultiple="false"
                    :currentValue="formBaseInfo.referenceContractNo"
                    @setSearchModal="setReferenceContract"
                  ></SearchModal>
                </el-form-item>
              </el-col>
            </el-row> -->
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="" prop="isRelatedOtherInstruction">
                  <el-checkbox
                    v-model="formBaseInfo.isRelatedOtherInstruction"
                    :disabled="relativeCheckFlag || showStatus === '3'"
                    >自动生成关联供应商发货指令号</el-checkbox
                  >
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="formBaseInfo.isRelatedOtherInstruction">
              <el-col :span="12">
                <el-form-item label="关联供应商发货指令号">
                  <el-input
                    v-model="formBaseInfo.relatedInstructionNo"
                    maxlength="256"
                    clearable
                    disabled
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="关联供应商发货指令的业务公司">
                  <el-input
                    maxlength="256"
                    v-model="formBaseInfo.relatedInstructionCompanyName"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="formBaseInfo.isRelatedOtherInstruction">
              <!-- fixbug 628 -->
              <el-col :span="12">
                <el-form-item label="关联采购合同号" prop="relatedInstructionPurchaseContractNo">
                  <el-select
                    class="inputWidth"
                    v-model="formBaseInfo.relatedInstructionPurchaseContractNo"
                    :disabled="relativeCheckFlag || showStatus === '1' || showStatus === '3'"
                    @change="handleContractNoChange"
                  >
                    <el-option
                      v-for="(item, index) in contractList"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="关联供应商的上游供应商" prop="relatedInstructionPartnerName">
                  <el-input v-model="formBaseInfo.relatedInstructionPartnerName" disabled>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row v-if="formBaseInfo.isRelatedOtherInstruction">
              <el-col :span="24">
                <el-form-item label="关联供应商的上游供应商发货单位">
                  <el-input v-model="formBaseInfo.d" maxlength="256" clearable> </el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row>
              <el-col :span="24">
                <el-form-item label="收货备注" prop="shippingMark">
                  <el-input v-model="formBaseInfo.shippingMark" maxlength="256" clearable>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-collapse-item>

      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            商品信息（行项目）
          </div>
        </template>
        <div class="collapse-content">
          <vxe-toolbar>
            <template v-slot:buttons v-if="detailDisable">
              <!-- <vxe-button
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                @click="insertEvent()"
              >{{$t("goods.button.addRow")}}</vxe-button> -->
              <!-- <vxe-button
                @click="addPaymentApply()"
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                >创建付款申请</vxe-button
              > -->
            </template>
            <template v-slot:buttons v-else>
              <!-- <vxe-button
                type="primary"
                icon="el-icon-copy-document"
                class="vxe-btn-primary"
                @click="handleCopy"
                >{{ $t('businessReceiptList.btnList.copySelect') }}</vxe-button
              > -->
              <vxe-button
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                @click="removeGoodsTable"
                >{{ $t('goods.button.deleteRow') }}</vxe-button
              >
            </template>
          </vxe-toolbar>
          <vxe-table
            border
            resizable
            v-if="showTable"
            show-overflow
            highlight-hover-row
            size="mini"
            ref="goodsTable"
            class="vxe-table-element"
            :edit-rules="goodsTableRules"
            :data="storageInstructionDetail"
            :edit-config="detailDisable ? {} : { trigger: 'click', mode: 'row' }"
            keep-source
          >
            <vxe-table-column type="checkbox" width="60" fixed="left"></vxe-table-column>
            <vxe-table-column type="seq" width="60"></vxe-table-column>
            <!-- 车牌号 -->
            <vxe-table-column
              field="carNo"
              title="车牌号"
              min-width="140"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.carNo"
                  @input="$refs.goodsTable.updateStatus(scope)"
                  clearable
                  maxlength="256"
                ></el-input>
              </template>
            </vxe-table-column>
            <!-- 商品描述 去掉了 :edit-render="{ name: 'default' }" 缺陷367 -->
            <vxe-table-column
              field="productDesc"
              width="150"
              :title="$t('addSupplierDelivery.detail.productDesc')"
            >
              <template v-slot:edit="scope">
                <search-table
                  v-model="scope.row.productDesc"
                  searchType="goodsDetail"
                  propName="detailProductDisplayName"
                  :isMultiple="true"
                  :currentValue="scope.row.productDesc ? scope.row.productDesc : ''"
                  :checkRowKeys="scope.row.productNo ? [scope.row.productNo] : []"
                  @input="(val) => chooseTable(val, scope.row, 'productDesc', scope)"
                  :disabled="true"
                ></search-table>
              </template>
            </vxe-table-column>
            <vxe-table-column field="roughWeight" width="150" title="毛重"></vxe-table-column>
            <vxe-table-column field="tare" width="150" title="皮重"></vxe-table-column>

            <vxe-table-column
              field="netWeight"
              title="净重"
              min-width="140"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <input-number
                  min="0"
                  max="'99999999999.9999'"
                  :precision="4"
                  v-model="scope.row.netWeight"
                  clearable
                ></input-number>
              </template>
            </vxe-table-column>
            <!-- 扣杂 -->
            <vxe-table-column
              field="deduct"
              title="扣杂"
              min-width="140"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <input-number
                  v-model="scope.row.deduct"
                  min="0"
                  max="'99999999999.9999'"
                  :precision="4"
                  clearable
                ></input-number>
              </template>
            </vxe-table-column>
            <vxe-table-column field="netReceipt" width="150" title="实收">
              <template v-slot="{ row }">{{ replaceZeroStr(row.netReceipt) }}</template>
            </vxe-table-column>
            <!-- 业务结算价 -->
            <vxe-table-column
              width="150"
              field="businessVariablePrice"
              title="业务结算价"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <input-number
                  :max="'99999999999.999999'"
                  :precision="6"
                  v-model="scope.row.businessVariablePrice"
                  @input="(val) => handleBusinessVariablePrice(val, scope.row, scope)"
                >
                </input-number>
              </template>
              <template v-slot="{ row }">{{
                replaceLastZeroStr(row.businessVariablePrice)
              }}</template>
            </vxe-table-column>
            <!-- 业务结算价含税金额 -->
            <vxe-table-column
              width="150"
              field="businessVariablePriceWithTax"
              title="业务结算价含税金额"
            >
              <!-- <template v-slot:edit="scope">
                <input-number
                  :max="'99999999999.999999'"
                  :v-model="
                    $baseRequest.formatTableColumn(
                      scope.row.businessVariablePriceWithTax,
                      $globalVar.aPoint
                    )
                  "
                  :precision="$globalVar.qPoint"
                ></input-number>
              </template> -->
              <template v-slot="{ row }">{{
                replaceZeroStr(row.businessVariablePriceWithTax)
              }}</template>
            </vxe-table-column>
            <!-- 采购合同项目号 -->
            <vxe-table-column
              field="purchaseContractDetailNo"
              width="150"
              title="采购合同行项目号"
            ></vxe-table-column>
            <vxe-table-column field="spec" width="150" title="规格"></vxe-table-column>

            <!-- 意向单号 -->
            <!-- <vxe-table-column
              field="purchaseIntentDetailNo"
              width="150"
              :title="$t('addSupplierDelivery.detail.purchaseIntentDetailNo')"
            ></vxe-table-column> -->
            <!-- 业务入库单号 -->
            <!-- <vxe-table-column
              field="businessInboundNo"
              width="150"
              title="业务入库单号"
            ></vxe-table-column> -->
            <!-- 入库批次号 -->
            <vxe-table-column
              field="businessInboundBatchNo"
              width="150"
              title="入库批次号"
            ></vxe-table-column>
            <!-- 商品编码 去掉了 :edit-render="{ name: 'default' }" 缺陷367 -->
            <vxe-table-column
              field="productNo"
              width="150"
              :title="$t('addSupplierDelivery.detail.productNo')"
            >
              <template v-slot:edit="scope">
                <search-table
                  v-model="scope.row.productNo"
                  searchType="goodsDetail"
                  propName="productDetailCode"
                  :isMultiple="true"
                  :currentValue="scope.row.productNo ? scope.row.productNo : ''"
                  :checkRowKeys="scope.row.productNo ? [scope.row.productNo] : []"
                  @input="(val) => chooseTable(val, scope.row, 'productNo', scope)"
                  :disabled="true"
                ></search-table>
              </template>
            </vxe-table-column>

            <!-- 签约数量 -->
            <!-- <vxe-table-column
              :visible="dataGroupHN"
              field="contractNo"
              :title="$t('addSupplierDelivery.detail.contractNo')"
              min-width="160"
            >
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.contractNo, $globalVar.qPoint)
              }}</template>
            </vxe-table-column> -->

            <!-- 供应商可发货指令数量 -->
            <vxe-table-column
              field="instructionAbleNumber"
              :title="$t('addSupplierDelivery.detail.instructionAbleNumber')"
              min-width="160"
            >
              <template v-slot="{ row }">{{
                replaceLastZeroStr($baseRequest.formatTableColumn(row.instructionAbleNumber, 2))
              }}</template>
            </vxe-table-column>

            <!-- 供应商发货指令数量 -->
            <vxe-table-column
              field="instructionNumber"
              :title="$t('addSupplierDelivery.detail.instructionNumber')"
              min-width="160"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <input-number
                  :max="'99999999999.9999'"
                  v-model="scope.row.instructionNumber"
                  :precision="4"
                  @input="(val) => instructionNumberChange(val, scope.row, scope)"
                ></input-number>
              </template>
              <template v-slot="{ row }">{{ replaceLastZeroStr(row.instructionNumber) }}</template>
            </vxe-table-column>

            <!-- 溢装比例 -->
            <vxe-table-column
              field="overShippedPercentage"
              width="150"
              :title="$t('addSupplierDelivery.detail.overShippedPercentage')"
              v-if="!isChengKuang"
            ></vxe-table-column>

            <!-- 单位 去掉了 :edit-render="{ name: 'default' }" 缺陷367-->
            <vxe-table-column field="unit" width="150" title="单位">
              <template v-slot:edit="scope">
                <el-select v-model="scope.row.unit" :clearable="true" disabled>
                  <el-option
                    v-for="item in unitOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <!-- <ajax-select v-model="scope.row.unit" :apiUrl="dictApi" :apiData="unitData" :clearable="true" disabled></ajax-select> -->
              </template>
              <template v-slot="{ row }">{{ transferSelectLabel(row.unit, unitOptions) }}</template>
            </vxe-table-column>

            <!-- 包装 -->
            <vxe-table-column
              field="packaging"
              :title="$t('addSupplierDelivery.detail.packaging')"
              min-width="140"
              v-if="!isChengKuang"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.packaging"
                  @input="$refs.goodsTable.updateStatus(scope)"
                  clearable
                  maxlength="32"
                ></el-input>
              </template>
            </vxe-table-column>
            <!-- 单位重量 -->
            <vxe-table-column
              field="unitWeight"
              :title="$t('addSupplierDelivery.detail.unitWeight')"
              min-width="140"
              v-if="!isChengKuang"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <input-number
                  :max="'99999999999.999999'"
                  v-model="scope.row.unitWeight"
                  :precision="6"
                  @input="$refs.goodsTable.updateStatus(scope)"
                ></input-number>
              </template>
            </vxe-table-column>
            <!-- 件数 -->
            <vxe-table-column
              field="unitNumber"
              title="件数"
              v-if="!isChengKuang"
              min-width="140"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <input-number
                  :max="'99999999999.999999'"
                  v-model="scope.row.unitNumber"
                  :precision="$globalVar.qPoint"
                  @input="$refs.goodsTable.updateStatus(scope)"
                ></input-number>
              </template>
            </vxe-table-column>
            <!-- 包装数量 -->
            <vxe-table-column
              :visible="!dataGroupHN"
              field="packagingNumber"
              :title="$t('addSupplierDelivery.detail.packagingNumber')"
              min-width="140"
              v-if="!isChengKuang"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <input-number
                  :max="'99999999999.999999'"
                  v-model="scope.row.packagingNumber"
                  :precision="$globalVar.qPoint"
                  @input="$refs.goodsTable.updateStatus(scope)"
                ></input-number>
              </template>
            </vxe-table-column>
            <!-- 包装单位 搜索弹窗 -->
            <vxe-table-column
              field="packagingUnit"
              width="150"
              v-if="!isChengKuang"
              :title="$t('addSupplierDelivery.detail.packagingUnit')"
              :edit-render="{ name: 'default' }"
            >
              <template v-slot:edit="scope">
                <!-- <ajax-select
                  v-model="scope.row.packagingUnit"
                  :apiUrl="dictApi"
                  :apiData="unitData"
                  :clearable="true"
                ></ajax-select> -->
                <el-select v-model="scope.row.packagingUnit" :clearable="true" filterable>
                  <el-option
                    v-for="item in unitOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </template>
              <template v-slot="{ row }">{{
                transferSelectLabel(row.packagingUnit, unitOptions)
              }}</template>
            </vxe-table-column>
            <!-- 仓库 -->
            <vxe-table-column
              field="storageName"
              width="150"
              :title="$t('addSupplierDelivery.detail.storageNo')"
            >
              <template v-slot:edit="scope">
                <search-table
                  v-model="scope.row.storageName"
                  searchType="warehouse"
                  :isMultiple="true"
                  :currentValue="scope.row.storageName ? scope.row.storageName : ''"
                  :checkRowKeys="scope.row.storageNo ? [scope.row.storageNo] : []"
                  @input="(val) => chooseTable(val, scope.row, 'storageName', scope)"
                  :disabled="true"
                ></search-table>
              </template>
            </vxe-table-column>

            <!-- 备注 -->
            <vxe-table-column
              field="mark"
              :title="$t('addSupplierDelivery.detail.mark')"
              min-width="140"
              v-if="!isChengKuang"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.mark"
                  @input="$refs.goodsTable.updateStatus(scope)"
                  clearableformBaseInfo
                  maxlength="256"
                ></el-input>
              </template>
            </vxe-table-column>
            <!-- 合同单价 -->
            <vxe-table-column width="150" field="contractUnitPrice" title="合同单价">
              <template v-slot="{ row }">{{ replaceLastZeroStr(row.contractUnitPrice) }}</template>
            </vxe-table-column>

            <!-- 海宁运费单价 -->
            <!-- <vxe-table-column
              :visible="dataGroupHN"
              width="150"
              field="shippingUnitExpense"
              :title="$t('addSupplierDelivery.detail.shippingUnitExpenseHN')"
            >
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.shippingUnitExpense, $globalVar.pPoint)
              }}</template>
            </vxe-table-column> -->
            <!-- 金额 -->
            <vxe-table-column width="150" field="totalAmount" title="金额">
              <template v-slot="{ row }">{{ replaceZeroStr(row.contractUnitPrice) }}</template>
            </vxe-table-column>

            <!-- <vxe-table-column
              field="instructionNumber"
              :title="$t('addSupplierDelivery.detail.instructionNumber')"
              min-width="160"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <input-number
                  :max="'99999999999.999999'"
                  v-model="scope.row.instructionNumber"
                  :precision="$globalVar.qPoint"
                  @input="(val) => instructionNumberChange(val, scope.row, scope)"
                ></input-number>
              </template>
            </vxe-table-column> -->
            <!-- 业务结算价不含税单价 -->
            <vxe-table-column
              width="150"
              field="businessVariablePriceWithoutTax"
              title="业务结算价不含税单价"
            >
              <!-- <template v-slot:edit="scope">
                <input-number
                  :max="'99999999999.999999'"
                  :v-model="
                    $baseRequest.formatTableColumn(
                      scope.row.businessVariablePriceWithoutTax,
                      $globalVar.aPoint
                    )
                  "
                  :precision="$globalVar.qPoint"
                ></input-number>
              </template> -->
              <template v-slot="{ row }">{{
                replaceLastZeroStr(row.businessVariablePriceWithoutTax)
              }}</template>
            </vxe-table-column>

            <!-- 含税金额 -->
            <!-- <vxe-table-column width="150" field="totalAmount" title="含税金额">
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.totalAmount, $globalVar.aPoint)
              }}</template>
            </vxe-table-column> -->
            <!-- 业务结算价净值 -->
            <vxe-table-column
              width="150"
              field="businessVariablePricePureAmount"
              title="业务结算价净值"
            >
              <template v-slot="{ row }">{{
                replaceLastZeroStr(
                  $baseRequest.formatTableColumn(row.businessVariablePricePureAmount, 6)
                )
              }}</template>
            </vxe-table-column>
            <!-- 业务结算价总税额 -->
            <!-- <vxe-table-column width="150" field="bbbb" title="业务结算价总税额">
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.totalAmount, $globalVar.aPoint)
              }}</template>
            </vxe-table-column> -->
            <!-- 业务结算价税额 -->
            <vxe-table-column
              width="150"
              field="businessVariablePriceTaxAmount"
              title="业务结算价税额"
            >
              <template v-slot="{ row }">{{
                replaceLastZeroStr(
                  $baseRequest.formatTableColumn(row.businessVariablePriceTaxAmount, 6)
                )
              }}</template>
            </vxe-table-column>
            <!-- 合同价含税金额 -->
            <vxe-table-column
              width="150"
              field="businessContractPriceWithTax"
              title="合同价含税金额"
            >
              <template v-slot="{ row }">{{
                replaceZeroStr(row.businessContractPriceWithTax)
              }}</template>
            </vxe-table-column>
            <!-- 合同价净值 -->
            <vxe-table-column
              width="150"
              field="businessContractPricePureAmount"
              title="合同价净值"
            >
              <template v-slot="{ row }">{{
                replaceLastZeroStr(
                  $baseRequest.formatTableColumn(row.businessContractPricePureAmount, 6)
                )
              }}</template>
            </vxe-table-column>
            <!-- 合同价税额 -->
            <vxe-table-column width="150" field="businessContractPriceTaxAmount" title="合同价税额">
              <template v-slot="{ row }">{{
                replaceLastZeroStr(
                  $baseRequest.formatTableColumn(row.businessContractPriceTaxAmount, 6)
                )
              }}</template>
            </vxe-table-column>
            <!-- 税率 -->
            <!-- <vxe-table-column width="150" field="taxRate" title="税率">
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.taxRate, 2)
              }}</template>
            </vxe-table-column> -->
            <vxe-table-column
              field="taxRate"
              title="税率"
              width="150"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <input-number
                  :max="'0.99'"
                  v-model="scope.row.taxRate"
                  :precision="2"
                  @input="(val) => taxRateNumberChange(val, scope.row, scope)"
                ></input-number>
              </template>
            </vxe-table-column>
            <!-- 备注 -->
            <vxe-table-column
              field="mark"
              :title="$t('addSupplierDelivery.detail.mark')"
              min-width="140"
              v-if="!isChengKuang"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.mark"
                  @input="$refs.goodsTable.updateStatus(scope)"
                  clearable
                  maxlength="256"
                ></el-input>
              </template>
            </vxe-table-column>

            <!-- 销售单价 -->
            <!-- <vxe-table-column
              :visible="dataGroupHN"
              width="150"
              field="salesContractUnitPrice"
              :title="$t('addSupplierDelivery.detail.salesContractUnitPrice')"
            >
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.salesContractUnitPrice, $globalVar.pPoint)
              }}</template>
            </vxe-table-column> -->
            <!-- 销售运费单价 -->
            <!-- <vxe-table-column
              :visible="dataGroupHN"
              width="150"
              field="salesShippingUnitExpense"
              :title="$t('addSupplierDelivery.detail.salesShippingUnitExpense')"
            >
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.salesShippingUnitExpense, $globalVar.pPoint)
              }}</template>
            </vxe-table-column> -->
            <!-- 销售金额 -->
            <!-- <vxe-table-column
              :visible="dataGroupHN"
              width="150"
              field="salesContractTotalAmount"
              :title="$t('addSupplierDelivery.detail.salesContractTotalAmount')"
            >
              <template v-slot="{ row }">{{
                $baseRequest.formatTableColumn(row.salesContractTotalAmount, $globalVar.aPoint)
              }}</template>
            </vxe-table-column> -->

            <!-- <vxe-table-column
              field="distributionBatchNo"
              title="物流批次号"
              min-width="140"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.distributionBatchNo"
                  clearable
                  maxlength="32"
                ></el-input>
              </template>
            </vxe-table-column> -->
          </vxe-table>
        </div>
      </el-collapse-item>

      <!-- <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('addSupplierDelivery.detail.transportInfo') }}
          </div>
        </template>
        <div class="collapse-content">
          <el-form ref="tableform" size="mini" label-width="60px">
            <el-row>
              <el-col :span="6">
                <el-form-item
                  :label="$t('addSupplierDelivery.detail.distributionMode')"
                  prop="distributionMode"
                >
                  <ajax-select
                    v-model="formBaseInfo.distributionMode"
                    :apiUrl="dictApi"
                    :apiData="deliveryMethodData"
                    :disabled="true"
                  ></ajax-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <vxe-toolbar>
            <template v-slot:buttons>
              <vxe-button
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                @click="insertEvent()"
                >{{ $t('goods.button.addRow') }}</vxe-button
              >
              <vxe-button
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                @click="remove()"
                >{{ $t('goods.button.deleteRow') }}</vxe-button
              >
            </template>
          </vxe-toolbar>
          <vxe-table
            border
            resizable
            show-overflow
            highlight-hover-row
            size="mini"
            ref="xTable"
            class="vxe-table-element"
            :data="storageInstructionTransport"
            :edit-config="{ trigger: 'click', mode: 'row' }"
            :valid-config="{ autoPos: true, message: 'inline' }"
          >
            <vxe-table-column type="checkbox" width="60" fixed="left"></vxe-table-column>
            <vxe-table-column
              field="nameVoyageLicense"
              min-width="150"
              :title="$t('addSupplierDelivery.detail.vesselName')"
              :edit-render="{ name: 'ElInput' }"
            >
              <template v-slot:edit="scope">
                <el-input v-model="scope.row.nameVoyageLicense" maxlength="32" clearable></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="freightInformation"
              min-width="150"
              :title="$t('addSupplierDelivery.detail.freightInformation')"
              :edit-render="{ name: 'ElInput' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.freightInformation"
                  maxlength="32"
                  clearable
                ></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="contactPerson"
              min-width="150"
              :title="$t('addSupplierDelivery.detail.contactPerson')"
              :edit-render="{ name: 'ElInput' }"
            >
              <template v-slot:edit="scope">
                <el-input v-model="scope.row.contactPerson" maxlength="32" clearable></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="contactPhoneNo"
              min-width="150"
              :title="$t('addSupplierDelivery.detail.contactPhoneNo')"
              :edit-render="{ name: 'ElInput' }"
            >
              <template v-slot:edit="scope">
                <el-input v-model="scope.row.contactPhoneNo" maxlength="32" clearable></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="identityCardNumber"
              min-width="150"
              :title="$t('addSupplierDelivery.detail.identityCardNumber')"
              :edit-render="{ name: 'ElInput' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  v-model="scope.row.identityCardNumber"
                  maxlength="32"
                  clearable
                ></el-input>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
      </el-collapse-item> -->
      <!--附件-->
      <el-collapse-item name="4">
        <!-- <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('returnDetail.collapseTitle.fileTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <upload
            ref="upload"
            defaultPath="scm/warehouseContract"
            :tableData="storageAttachment"
            @upload="uploadList"
            :isShow="!detailDisable"
          />
        </div> -->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="fileTableRef"
            :attachments="storageAttachment"
            :isDisabledDelete="showStatus === '1'"
            :isDisabledUpload="showStatus === '1'"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 0已保存，1已确认，2已业务入库，3已撤销 现在只有已保存0 已业务入库1 已撤销3三种状态 -->
    <div class="fixed-bottom-btnList">
      <el-button v-if="showStatus !== '1'" type="primary" @click="save(0)">保存</el-button>
      <!-- <el-button
        type="primary"
        v-hasPermi="['2021042915510723653']"
        @click="save(0)"
        :disabled="showStatus == 1 || showStatus == 2"
        >保存</el-button
      > -->
      <!-- <el-button
        type="primary"
        @click="checkSave(1)"
        v-if="
          formInline.instructionType == 'ZL01' ||
          formInline.instructionType == 'ZL02' ||
          formInline.instructionType == 'ZL03'
        "
        :disabled="
          showStatus == 1 ||
          showStatus == 2 ||
          (formInline.directDeliver == '1' && formInline.deliverMethod != '1')
        "
        >提交物流</el-button
      > -->
      <!-- 运输格式打印 -->
      <!-- <el-button type="primary" @click="checkSave" :disabled="showStatus == 1 || showStatus == 2">运输格式打印</el-button> -->
      <!-- <el-button
        type="primary"
        v-hasPermi="['2021042915515682556']"
        @click="applayTransfer()"
        :disabled="showStatus == '' || !(formInline.deliverMethod == '1' && showStatus == '0')"
        >申请运输</el-button
      > -->
      <!-- 生成业务入库单 -->
      <!-- <el-button
        type="primary"
        v-hasPermi="['2021042915522060245']"
        @click="checkSave(2)"
        :disabled="showStatus == 1 || showStatus == 2 || formInline.directDeliver !== '1'"
        >提交</el-button
      > -->
      <!-- <el-button
        v-if="showStatus !== '1' || formInline.directDeliver !== '1'"
        type="primary"
        v-hasPermi="['2021042915522060245']"
        @click="checkSave(1)"
        >提交生效</el-button
      > fixbug 617 -->

      <el-button v-if="showStatus !== '1'" type="primary" @click="checkSave(1)">提交生效</el-button>
      <!-- <el-button
        type="primary"
        v-hasPermi="['2021042915525016277']"
        @click="withdraw"
        :disabled="showStatus != 1 && showStatus ! 2"
        >撤回</el-button
      > -->
      <el-button
        v-if="showStatus === '1'"
        type="primary"
        v-hasPermi="['2021042915525016277']"
        @click="withdraw"
        >撤回</el-button
      >
      <el-button
        v-if="showStatus === '0' || showStatus === '3'"
        type="primary"
        v-hasPermi="['2021042915531474306']"
        @click="delte"
        >删除</el-button
      >
      <el-button type="primary" @click="printHandler" v-if="showStatus == '1'">打印</el-button>
      <!-- <el-button
        type="primary"
        v-hasPermi="['2021042915531474306']"
        @click="delte"
        :disabled="showStatus != 0 && showStatus != 3"
        >删除</el-button
      > -->
      <!-- <el-button
        @click="upload(1)"
        :disabled="showStatus == 1 || showStatus == 2"
      >{{isShowBtn == 1? this.$t("addSupplierDelivery.detail.upload"):this.$t("addSupplierDelivery.detail.download")}}</el-button>-->
    </div>
    <!-- <uploadDialog ref="uploadDialog"></uploadDialog> -->

    <SelectTableDialog
      title="收货地址"
      :columnList="contractColumnList"
      :defaultVisible="defaultVisible"
      :API="addrAPI"
      :extraData="addrExtraData"
      :confirmUnchecked="false"
      :isMultiple="false"
      :type="addrType"
      :page="1 != 1"
      width="1200px"
      @close="close"
      @confirm="confirmAddr"
    >
    </SelectTableDialog>
    <!-- 打印弹框 -->
    <PrintDialog ref="printDialogRef" :apiUrl="printApi" />
  </div>
</template>

<script>
  // import uploadDialog from "./uploadDialog"
  // import Upload from '@/components/upload';
  // import SearchModal from '@/components/SearchModal';
  // import { async } from 'q';
  import { mapState } from 'vuex';
  import searchTable from '@/components/form-item/search-table';
  import ajaxSelect from '@/pages/wareHouse/stockManage/components/ajax-select';
  import API from '@/api/wareHouse/supplierDeliveryOrder.js';
  import ConAPI from '@/api/purchaseSalesCenter/credit/applicationCredit.js';
  import inputNumber from '@/components/form-item/input-number';
  // import loading from '@/common/js/load.js'; //loading
  import SelectTableDialog from '@/components/SelectTableDialog';
  import BASE_API from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  // import BASE_API from '@/api/dataBase.js';
  export default {
    components: {
      // SearchModal,
      // uploadDialog,
      searchTable,
      ajaxSelect,
      // Upload,
      inputNumber,
      SelectTableDialog,
    },
    name: 'addSupplierDelivery',
    data() {
      console.log(this, '===111====');
      return {
        // rowMergeArrs: [],
        // needMergeArr: ['productDesc', 'instructionAbleNumber'],
        // purchaseContractDetailNo: [],
        platformCompanyList: [],
        baseNameList: [],
        detailDisable: false,
        addrAPI: API.GET_PARTNER_PERSON,
        printApi: API.PRINT_API,
        addrExtraData: {},
        defaultVisible: false,
        addrType: 'get',
        addrDataKey: 'partnersPersons',
        dataGroupHN: false, //判断订单是否来自海宁
        showTable: true,
        isDirectDeliverFlag: '',
        contractNo: '', //引用的采购合同号
        activeNames: ['1', '2', '3', '4'], //默认展开那些面板，
        dictApi: API.DATA_DICT, // TODO 测试api
        statusApiData: {},
        operationModeData: {},
        deliveryMethodData: {},
        unitData: {},
        currencyData: {},
        currencyApi: '', //货币种类api
        formInline: {
          //头部基本信息加上登陆信息和id/version
          id: '',
          version: '',
          tenantCode: '',
          companyNo: '',
          companyName: '',
          instructionCompanyNo: '',
          instructionCompanyName: '',
          departmentCode: '',
          departmentName: '',
          instructionNo: '',
          instructionStatus: '',
          instructionCreatePersonName: '',
          instructionType: '',
          directDeliver: '',
          // deliverMethod: '',
          instructionCreateDate: '', //创建日期
          businessInboundNo: '', // 业务入库单号
        },
        formBaseInfo: {
          partnerName: '', // 供应商
          partnerNo: '', // 供应商
          customerName: null,
          customerNo: null,
          instructionDepartmentNo: '',
          instructionDepartmentName: '', // 部门
          salesmanNo: '', // 业务员
          salesmanName: '',
          deliverFromAddress: '', // 发货详情地址
          deliverToStorageNo: '', // 收货仓库
          deliverToStorageName: '', // 收货仓库
          purchaseContractNo: '', // 采购合同号
          // purchaseIntentNo: '', // 意向单号
          deliverDate: '', // 发货日期
          expectArrivalDate: '', // 预计到货日期
          // flowDirection: '', // 流向
          // registrationNo: '',  prd 上无
          insured: '', // 是否投保
          externalContractNo: '', // 外部合同号
          shippingContact: '', // 发货联系方式
          businessMode: '', // 业务性质
          shipingMethod: '', // 运输方式
          deliverFromStorageNo: '', // 发货仓库
          deliverFromStorageName: '', // // 发货仓库
          shippingContactPerson: '', // 发货联系人
          // marineLadingNo: '',  prd 无海运提单号
          // warehouseReceiptsNo: '', prd 期货仓单号
          shippingMark: '', // 收货备注
          contractDetailCategory: '',
          deliverToAddress: '',
          inboundDate: '', // 业务入库日期
          platformCompanyCode: '', // 平台公司编码
          platformCompanyName: '', // 平台公司名称
          baseName: '', // 基地简称
          referenceContractNo: '', // 关联合同号
          isRelatedOtherInstruction: false, // 自动生成城矿公司供应商发货指令号
          relatedInstructionNo: '', // 关联供应商发货指令号
          relatedInstructionCompanyName: '', // 关联供应商发货指令的业务公司
          relatedInstructionPurchaseContractNo: '', // 关联采购合同号
          relatedInstructionPartnerName: '', // 关联供应商的上游供应商
        },
        //load: false,
        storageInstructionDetail: [], //商品行项目信息
        storageInstructionTransport: [], //交通运输信息
        storageAttachment: [], //附件信息
        customerExtraData: {}, // 设置客户筛选条件
        // tableColumn: [
        //   {
        //     type: 'index',
        //     title: this.$t('addSupplierDelivery.detail.indexNum'),
        //     width: 80,
        //   },
        //   {
        //     field: 'purchaseContractDetailNo',
        //     title: this.$t('addSupplierDelivery.detail.purchaseContractDetailNo'),
        //     width: 150,
        //   },
        //   // {
        //   //   field: "purchaseIntentDetailNo",
        //   //   title: this.$t("addSupplierDelivery.detail.purchaseIntentDetailNo"),
        //   //   width: 150
        //   // },
        //   {
        //     field: 'productNo',
        //     title: this.$t('addSupplierDelivery.detail.productNo'),
        //     editRender: { name: 'ElInput' },
        //     width: 150,
        //   },
        //   {
        //     field: 'productDesc',
        //     title: this.$t('addSupplierDelivery.detail.productDesc'),
        //     editRender: { name: 'ElInput' },
        //     width: 150,
        //   },
        //   {
        //     //签约数量
        //     field: 'contractNo',
        //     title: this.$t('addSupplierDelivery.detail.contractNo'),
        //     width: 180,
        //   },
        //   {
        //     //供应商可发货指令数量
        //     field: 'instructionAbleNumber',
        //     title: this.$t('addSupplierDelivery.detail.instructionAbleNumber'),
        //     width: 180,
        //   },
        //   {
        //     //供应商发货指令数量
        //     field: 'instructionNumber',
        //     title: this.$t('addSupplierDelivery.detail.instructionNumber'),
        //     editRender: { name: 'ElInput' },
        //     width: 180,
        //   },
        //   {
        //     field: 'overShippedPercentage',
        //     title: this.$t('addSupplierDelivery.detail.overShippedPercentage'),
        //     width: 150,
        //   },
        //   {
        //     field: 'unit',
        //     title: this.$t('addSupplierDelivery.detail.unit'),
        //     editRender: { name: 'ElInput' },
        //     width: 150,
        //   },
        //   {
        //     field: 'packaging',
        //     title: this.$t('addSupplierDelivery.detail.packaging'),
        //     editRender: { name: 'ElInput' },
        //     width: 150,
        //   },
        //   {
        //     field: 'unitWeight',
        //     title: this.$t('addSupplierDelivery.detail.unitWeight'),
        //     editRender: { name: 'ElInput' },
        //     width: 150,
        //   },
        //   {
        //     field: 'unitNumber',
        //     title: this.$t('addSupplierDelivery.detail.unitNumber'),
        //     editRender: { name: 'ElInput' },
        //     width: 150,
        //   },
        //   {
        //     field: 'packagingNumber',
        //     title: this.$t('addSupplierDelivery.detail.packagingNumber'),
        //     editRender: { name: 'ElInput' },
        //     width: 150,
        //   },
        //   {
        //     field: 'packagingUnit',
        //     title: this.$t('addSupplierDelivery.detail.packagingUnit'),
        //     editRender: { name: 'ElInput' },
        //     width: 150,
        //   },
        //   {
        //     field: 'storageNo',
        //     title: this.$t('addSupplierDelivery.detail.storageNo'),
        //     editRender: { name: 'ElInput' },
        //     width: 150,
        //   },
        //   {
        //     field: 'mark',
        //     title: this.$t('addSupplierDelivery.detail.mark'),
        //     editRender: { name: 'ElInput' },
        //     width: 150,
        //   },
        //   {
        //     field: 'distributionNo',
        //     title: this.$t('addSupplierDelivery.detail.distributionNo'),
        //     width: 150,
        //   },
        // ],
        instructionNo: '', //接受的供应商发货指令
        showStatus: '', //按钮显示状态  0已保存，1已确认，2已业务入库，3已撤销
        judgeType: '',
        isShowBtn: '', //1编辑   2查看
        // extraData: {
        //   adminFlag: this.adminFlag,
        //   currentStatus: 'ZT03', //已生效的仓库
        // },
        contractList: [],
        relativeCheckFlag: false,
        isOutLink: false, // 是否外部跳转过来的
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        //单位下拉1
        unitOptions() {
          // if(state.dict.dictList.length>10){
          //   return  state.dict.dictList.find(it=>it.dictType=="basic_unit").dictList;
          // }
          return this.$baseRequest.getDictListByType('basic_unit');
        },
        instuctionTypeList() {
          let key = 'instruction_type';
          return this.$baseRequest.getDictListByType(key);
        },
      }),
      isChengKuang() {
        return this.userInfo.businessGroup == '城矿';
      },
      //关联合同号
      referenceContract() {
        return {
          API: ConAPI.CONTRACT_API,
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            listStatus: ['ZT06', 'ZT02'],
            partnerCode: this.formBaseInfo.partnerNo,
          },
          columnList: [
            { prop: 'contractNo', label: window.vm.$t('applicationCredit.table.contractNo') },
            {
              prop: 'contractStatusName',
              label: window.vm.$t('applicationCredit.table.requestStatus'),
            },
          ],
        };
      },

      contractColumnList() {
        return [
          {
            prop: 'contactPersonName',
            label: '联系人',
          },
          {
            prop: 'address',
            label: '地址',
          },
        ];
      },
      formInlineRules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          // instructionStatus: [
          //   {
          //     required: true,
          //     message: '请输入',
          //     trigger: 'blur',
          //   },
          // ],
          instructionCreatePersonName: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
            {
              min: 1,
              message: this.$t('company.companyNameWordNumber'),
              trigger: ['blur'],
            },
            { validator: specialValidate, trigger: ['blur'] },
          ],
          instructionCompanyName: [
            {
              required: true,
              message: '请输入公司名称',
              trigger: 'blur',
            },
            {
              min: 1,
              message: this.$t('company.companyNameWordNumber'),
              trigger: ['blur'],
            },
            { validator: specialValidate, trigger: ['blur'] },
          ],
          // instructionType: [
          //   {
          //     required: true,
          //     message: '请选择发货指令类型',
          //     trigger: ['blur', 'change'],
          //   },
          //   {
          //     min: 1,
          //     message: this.$t('company.companyNameWordNumber'),
          //     trigger: ['blur'],
          //   },
          //   { validator: specialValidate, trigger: ['blur'] },
          // ],
          // directDeliver: [
          //   {
          //     required: true,
          //     message: "请输入",
          //     trigger: ["blur", "change"]
          //   },
          //   {
          //     min: 1,
          //     message: this.$t("company.companyNameWordNumber"),
          //     trigger: ["blur", "change"]
          //   },
          //   { validator: specialValidate, trigger: ["blur"] }
          // ],
          // deliverMethod: [
          //   {
          //     required: true,
          //     message: "请输入",
          //     trigger: ["blur", "change"]
          //   },
          //   {
          //     min: 1,
          //     message: this.$t("company.companyNameWordNumber"),
          //     trigger: ["blur", "change"]
          //   },
          //   { validator: specialValidate, trigger: ["blur"] }
          // ]
        };
      },
      formBaseInfoRules() {
        let validator1 = (rule, value, callback) => {
          let fullData = this.$refs.goodsTable?.getTableData().fullData || [];
          let storageNoArr = [];
          fullData.map((item) => {
            if (!storageNoArr.includes(item.storageNo)) storageNoArr.push(item.storageNo);
          });
          if (storageNoArr.length > 1) {
            callback(new Error('行项目仓库不一致,请修改收货仓库'));
          } else {
            callback();
          }
        };
        return {
          // auto: [
          //   {
          //     required: true,
          //     message: '请选择自动生成城矿公司供应商发货指令号',
          //     trigger: 'blur',
          //   },
          // ],
          inboundDate: [
            {
              required: true,
              message: '请选择业务入库日期',
              trigger: 'blur',
            },
          ],
          platformCompanyCode: [
            {
              required: true,
              message: '请选择平台公司',
              trigger: 'blur',
            },
          ],
          // baseName: [
          //   {
          //     required: true,
          //     message: '请选择基地简称',
          //     trigger: 'blur',
          //   },
          // ],
          deliverDate: [
            {
              required: true,
              message: '请选择发货日期',
              trigger: 'blur',
            },
          ],
          expectArrivalDate: [
            {
              required: true,
              message: '请选择预计到货日期',
              trigger: ['blur', 'change'],
            },
          ],
          purchaseContractNo: [
            {
              required: true,
              message: '请填写采购合同号',
              trigger: ['blur', 'change'],
            },
          ],
          // purchaseIntentNo: [
          //   {
          //     required: true,
          //     message: '请填写意向单号',
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          partnerName: [
            {
              required: true,
              message: '请选择供应商',
              trigger: ['blur'],
            },
          ],
          instructionDepartmentName: [
            {
              required: true,
              message: '请选择部门',
              trigger: ['blur'],
            },
          ],
          salesmanNo: [
            {
              required: true,
              message: '请选择业务员',
              trigger: ['blur'],
            },
          ],
          deliverToStorageNo: [
            {
              required: true,
              message: '请选择收货仓库',
              trigger: ['blur', 'change'],
            },
            {
              validator: validator1,
            },
          ],
          businessMode: [
            {
              required: true,
              message: '请选择业务性质',
              trigger: ['blur', 'change'],
            },
          ],
          // deliverFromAddress: [
          //   {
          //     required: this.formInline.deliverMethod == '1' ? true : false,
          //     message: '请输入',
          //     trigger: 'blur',
          //   },
          // ],
          // distributionMode: [
          //   {
          //     required: true,
          //     message: '请选择运输方式',
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          referenceContractNo: [
            {
              required: true,
              message: '请选择关联合同号',
              trigger: ['blur', 'change'],
            },
          ],
          // flowDirection: [
          //   {
          //     required:
          //       this.formInline.directDeliver == '1'
          //         ? false
          //         : this.formBaseInfo.deliverToStorageNo
          //         ? false
          //         : true,
          //     message: '请输入',
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          // relatedInstructionCompanyName: [
          //   {
          //     required: this.formBaseInfo.isRelatedOtherInstruction,
          //     message: '请选择关联供应商发货指令的业务公司',
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          relatedInstructionPurchaseContractNo: [
            {
              required: this.formBaseInfo.isRelatedOtherInstruction,
              message: '请选择关联采购合同号',
              trigger: ['blur', 'change'],
            },
          ],
          relatedInstructionPartnerName: [
            {
              required: this.formBaseInfo.isRelatedOtherInstruction,
              message: '请选择关联供应商的上游供应商',
              trigger: ['blur', 'change'],
            },
          ],
          projectInitiationNo: [
            {
              required: this.isOutLink,
              message: '项目为必填字段',
              trigger: ['blur', 'change'],
            },
          ],
        };
      },
      goodsTableRules() {
        return {
          productNo: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          productDesc: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          instructionNumber: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          businessVariablePrice: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          unit: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          storageNo: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          carNo: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          netWeight: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
          deduct: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur',
            },
          ],
        };
      },
      transportDataRules() {
        //非直拨  供应商配送
        if (this.formInline.deliverMethod == '0' && this.formInline.directDeliver == '0') {
          return {
            nameVoyageLicense: [
              {
                required: true,
                message: '请输入',
                trigger: 'blur',
              },
            ],
            freightInformation: [
              {
                required: true,
                message: '请输入',
                trigger: 'blur',
              },
            ],
            contactPerson: [
              {
                required: true,
                message: '请输入',
                trigger: 'blur',
              },
            ],
            contactPhoneNo: [
              {
                required: true,
                message: '请输入',
                trigger: 'blur',
              },
            ],
            identityCardNumber: [
              {
                required: true,
                message: '请输入',
                trigger: 'blur',
              },
            ],
          };
        } else {
          return {};
        }
      },
    },
    // watch: {
    //   storageInstructionDetail: {
    //     immediate: true, // 这句重要
    //     handler() {
    //       this.rowSpan();
    //     },
    //   },
    // },
    created() {
      const tenantCode = this.userInfo.tenantCode;
      this.operationModeData = { dictType: 'purchase_business_type', tenantCode };
      this.deliveryMethodData = { dictType: 'delivery_method', tenantCode };
      this.statusApiData = { dictType: 'request_status', tenantCode };
      this.getCompanyList();
      // this.getBaseNameList();
      // this.getRelateCompanyList();
    },
    mounted() {
      this.judge();
      this.currencyApi = API.LIST_CURRENCY;
    },
    methods: {
      // 打印
      printHandler() {
        this.$refs.printDialogRef.openDialog({
          instructionNo: this.$route.query.instructionNo,
          downloadOrPrint: 'print',
        });
      },
      handlePlatformChange(val) {
        this.formBaseInfo.platformCompanyName = this.transferSelectLabel(
          val,
          this.platformCompanyList,
          'personCompanyCode',
          'personCompanyName'
        );
      },
      getCompanyList() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            console.log(res, '111111111111111111');
            this.platformCompanyList = res.data.data.personCompanyInfo || [];
          }
        });
      },
      getBaseNameList(contractNo) {
        if (!contractNo) return;
        const params = {
          contractNo: contractNo,
          departmentCode: this.userInfo.departmentCode,
        };
        this.$axios.post(API.CUSTOMER_ADDRESS, params).then((res) => {
          console.log(res, '=======');
          if (res.data.code === 0) {
            this.baseNameList = res.data.data || [];
          }
        });
      },
      handleContractNoChange(val) {
        this.contractList.forEach((contract) => {
          if (contract.label === val) {
            this.formBaseInfo.relatedInstructionPartnerName = contract.supplierName;
          }
        });
      },
      getTotal(total, val) {
        return total * val;
      },
      getRelateCompanyList(companyCode, companyName) {
        console.log(companyCode, companyName, '1111');
        // if (!companyCode) return;
        // const params = {
        //   adminFlag: this.userInfo.adminFlag,
        //   partnerType: 'HZHB11',
        //   requestStatus: 'ZT03',
        //   ifCreditPartner: '1',
        //   companyCode: companyCode,
        // };
        // this.$axios.post(API.PARTNER_LIST_API, params).then((res) => {
        //   console.log(res, '------');
        //   if (res.data.code === 0) {
        //     const companyList = [];
        //     let list = res.data.data || [];
        //     list.map((item) => {
        //       companyList.push(item.companyName || '');
        //     });
        //     if (companyList.includes(companyName)) {
        //       this.relativeCheckFlag = false;
        //     } else {
        //       this.relativeCheckFlag = true;
        //     }
        //   }
        // });
        this.$axios
          .post(API.DATA_DICT, {
            dictType: 'INNER_COMPANY',
            tenantCode: this.userInfo.tenantCode,
          })
          .then((res) => {
            if (res.data.code === 0) {
              console.log(res, '000000');
              const dataArr = res.data.data || [];
              const innerCompanyList = [];
              dataArr.forEach((item) => {
                innerCompanyList.push(item.label);
              });
              console.log(innerCompanyList, 'innerCompanyList');
              console.log(companyName, 'companyName');
              if (innerCompanyList.includes(companyName)) {
                this.relativeCheckFlag = false;
                this.formBaseInfo.isRelatedOtherInstruction = true;
              } else {
                this.relativeCheckFlag = true;
              }
            }
          });
        // if (companyName === COMPANY_CODE3) {
        //   console.log('22222222');
        //   // 不禁用 默认勾选
        //   this.relativeCheckFlag = false;
        //   this.formBaseInfo.isRelatedOtherInstruction = true;
        // } else {
        //   // 禁用
        //   console.log('3333333');
        //   this.relativeCheckFlag = true;
        // }
      },
      chooseAddr() {
        this.defaultVisible = true;
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
      // 弹窗确认
      confirmAddr(selections) {
        this.formBaseInfo.deliverToAddress = selections[0].address;
        this.defaultVisible = false;
      },
      //表单下拉表格赋值
      chooseForm(val, field) {
        if (field === 'partnerNo') {
          //供应商
          const partner = val ? val[0] : null;
          if (partner) {
            this.formBaseInfo.partnerName = partner.partnerZhName;
            this.formBaseInfo.partnerNo = partner.partnerCode;
          } else {
            //重置
            this.formBaseInfo.partnerName = '';
            this.formBaseInfo.partnerNo = '';
          }
        } else if (field === 'customerNo') {
          //供应商
          const customer = val ? val[0] : null;
          if (customer) {
            this.formBaseInfo.customerName = customer.partnerZhName;
            this.formBaseInfo.customerNo = customer.partnerCode;
          } else {
            //重置
            this.formBaseInfo.customerName = '';
            this.formBaseInfo.customerNo = '';
          }
          this.addrExtraData.partnerCode = this.formBaseInfo.customerNo;
        } else if (field === 'salesmanNo') {
          //业务员
          const salesman = val ? val[0] : null;
          if (salesman) {
            this.formBaseInfo.salesmanName = salesman.personName;
            this.formBaseInfo.salesmanNo = salesman.personNo;
          } else {
            this.formBaseInfo.salesmanName = '';
            this.formBaseInfo.salesmanNo = '';
          }
        } else if (field === 'deliverFromStorageNo') {
          //发货仓库
          const wareHouse = val ? val[0] : null;
          if (wareHouse) {
            this.formBaseInfo.deliverFromStorageNo = wareHouse.storageCode;
            this.formBaseInfo.deliverFromStorageName = wareHouse.storageName;
          } else {
            this.formBaseInfo.deliverFromStorageNo = '';
            this.formBaseInfo.deliverFromStorageName = '';
          }
        } else if (field === 'deliverToStorageNo') {
          // if (this.formInline.directDeliver == '0') {
          //   this.extraData.isDirectDeliver = "0"
          // } else {
          //   this.extraData.isDirectDeliver = '1'
          // }
          this.$refs['formBaseInfo'].clearValidate();
          //收货仓库
          const wareHouse = val ? val[0] : null;
          if (wareHouse) {
            this.formBaseInfo.deliverToStorageNo = wareHouse.storageCode;
            this.formBaseInfo.deliverToStorageName = wareHouse.storageName;
          } else {
            //重置
            this.formBaseInfo.deliverToStorageNo = '';
            this.formBaseInfo.deliverToStorageName = '';
            this.$refs.formBaseInfo.clearValidate('deliverToStorageNo');
          }
          this.storageInstructionDetail.forEach((item) => {
            (item.storageNo = this.formBaseInfo.deliverToStorageNo),
              (item.storageName = this.formBaseInfo.deliverToStorageName);
          });
        } else if (field == 'projectInitiationNo') {
          const partner = val ? val[0] : null;
          console.log('项目', partner);
          this.formBaseInfo.projectName = partner.projectAbbreviation;
          this.formBaseInfo.projectInitiationNo = partner.projectInitiationNo;
        }
      },
      //表格下拉表格赋值
      chooseTable(val, row, field, scope) {
        if (field === 'productNo' || field === 'productDesc') {
          //商品
          const product = row[field] ? row[field][0] : null;
          //如果没有选产品 则不走下面的逻辑
          if (product) {
            row.productNo = product.productDetailCode || null;
            row.productDesc = product.detailProductDisplayName;
          }
        } else if (field === 'storageName') {
          //仓库
          const wareHouse = row[field] ? row[field][0] : null;
          //如果没有选产品 则不走下面的逻辑
          if (wareHouse) {
            row.storageNo = wareHouse.storageCode || null;
            row.storageName = wareHouse.storageName;
          }
        }
        this.$refs.goodsTable.updateStatus(scope);
      },
      //流向发生变化
      changeFlowDirection() {
        this.$refs.formBaseInfo.clearValidate('deliverToStorageNo');
      },
      //供应商发货指令数量行发生变化
      instructionNumberChange(val, row, scope) {
        if (val) {
          //如果有数量 则计算
          if (this.dataGroupHN) {
            row.salesContractTotalAmount = this.$cal.calCommon(
              val,
              row.salesContractUnitPrice,
              '*',
              'amount'
            );
          }
          row.totalAmount = this.$cal.calCommon(val, row.contractUnitPrice, '*', 'amount');
          row.businessVariablePriceWithTax = val * row.businessVariablePrice;
          row.businessVariablePricePureAmount = val * row.businessVariablePriceWithoutTax;
          row.businessVariablePriceTaxAmount =
            row.businessVariablePriceWithTax - row.businessVariablePricePureAmount; // 业务结算价税额
        }
        this.$refs.goodsTable.reloadRow(row);
        this.$refs.goodsTable.updateStatus(scope);
      },
      // 业务结算价发生变化
      handleBusinessVariablePrice(val, row, scope) {
        row.businessVariablePriceWithoutTax = val * (1 - row.taxRate); // 业务结算价不含税单价
        row.businessVariablePriceWithTax = val * row.instructionNumber; // 业务结算价含税金额 = 供应商发货指令数*业务结算价
        row.businessVariablePricePureAmount =
          row.instructionNumber * row.businessVariablePriceWithoutTax; // 业务结算价净值 = 采购数量 * 业务结算价不含税单价
        row.businessVariablePriceTaxAmount =
          row.businessVariablePriceWithTax - row.businessVariablePricePureAmount; // 业务结算价税额
        row.businessVariablePrice = this.$baseRequest.formatTableColumn(val, 2);
        this.$refs.goodsTable.reloadRow(row);
        this.$refs.goodsTable.updateStatus(scope);
      },
      // 税率发生变化
      taxRateNumberChange(val, row, scope) {
        row.businessVariablePriceWithoutTax = row.businessVariablePrice * (1 - val); // 业务结算价不含税单价
        row.businessVariablePricePureAmount =
          row.instructionNumber * row.businessVariablePriceWithoutTax; // 业务结算价净值 = 采购数量 * 业务结算价不含税单价
        row.businessVariablePriceTaxAmount =
          row.businessVariablePriceWithTax - row.businessVariablePricePureAmount; // 业务结算价税额 = 业务结算价含税金额 - 业务结算价净值
        this.$refs.goodsTable.reloadRow(row);
        this.$refs.goodsTable.updateStatus(scope);
      },
      //下拉表格的清空
      // resetModelFun(obj) {
      //   if (obj.propCode == "storageCode") {
      //     this.formBaseInfo.deliverToStorageNo = "";
      //   }
      // },
      judge() {
        this.judgeType = this.$route.query.type;
        this.isShowBtn = this.$route.query.flag;
        this.detailDisable = this.$route.query.disable;
        console.log(
          this.$route.query.type,
          this.$route.query.flag,
          this.$route.query.disable,
          '?????'
        );
        if (this.judgeType == 2) {
          //双击跳转过来
          this.instructionNo = this.$route.query.instructionNo;
          this.getDetail(API.DETAIL_DATA_API);
        } else if (this.judgeType == 3) {
          //复制
          this.instructionNo = this.$route.query.instructionNo;
          this.getDetail(API.COPY_DETAIL_DATA_API);
        } else {
          //新增时候 查询合同详情并给商品行项目信息赋值
          this.contractNo = this.$route.query.contractNo;
          this.getBaseNameList(this.contractNo || '0300184');
          this.formInline.instructionCreatePersonName = this.userInfo.userName;
          this.formInline.instructionCreateDate = new Date();
          this.formBaseInfo.expectArrivalDate = new Date();
          this.formBaseInfo.deliverDate = new Date();
          // this.formInline.instructionCreatePersonName = this.userInfo.userName;
          this.formInline.tenantCode = this.userInfo.tenantCode;
          this.formInline.companyNo = this.userInfo.companyCode;
          this.formInline.companyName = this.userInfo.companyName;
          this.formInline.departmentCode = this.userInfo.departmentCode;
          this.formInline.departmentName = this.userInfo.departmentName;
          // this.formInline.businessInboundNo = '暂未数据';
          let contractDetailNoList = this.$route.query.contractDetailNoList || [];
          // this.getGoodsDetail(contractDetailNoList);
          this.createShippingInstruction(contractDetailNoList);
        }
      },
      // 新增调用新的接口
      createShippingInstruction(contractDetailNoList) {
        if (!XEUtils.isArray(contractDetailNoList))
          contractDetailNoList = contractDetailNoList.split(',');
        this.loading.startLoading();
        this.showTable = false;
        let params = {
          contractNo: this.contractNo,
          contractDetailNoList,
        };
        this.isOutLink = true;
        this.$axios.post(API.CREATE_SHIPPING_INSTRUCTION, params).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            let data = res.data.data || {};
            console.log(data, '12345677');
            // 根据公司编号查合同
            // this.getContractList(data.companyCode);
            this.getContractList('广西物产城矿发展有限公司');
            // this.getRelateCompanyList(data.companyCode, data.companyName);
            this.dataGroupHN = data.dataGroup == 'hn';
            this.showTable = true;
            this.formInline.instructionType = data.instructionType;
            this.formInline.instructionCompanyNo = data.instructionCompanyNo;
            this.formInline.instructionCompanyName =
              data.instructionCompanyName || data.companyName;
            // 数据全部拷贝给基本信息
            this.formBaseInfo = XEUtils.clone(data, true);
            this.formBaseInfo.platformCompanyCode = data.instructionCompanyNo;
            this.formBaseInfo.platformCompanyName = data.instructionCompanyName || data.companyName;
            delete this.formBaseInfo.storageInstructionDetails;
            this.storageInstructionDetail = XEUtils.clone(data.storageInstructionDetails, true);
            // const query = this.$route.query;

            this.storageInstructionDetail.map((item) => {
              item.instructionAbleNumber = item.avaliableInstructionNumber; //供应商可发货指令数量
              item.productNo = item?.productDetailCode ? item?.productDetailCode : item?.productNo;
              item.businessContractPricePureAmount =
                (item?.businessContractPriceWithTax ? item?.businessContractPriceWithTax : 0) -
                (item?.businessContractPriceTaxAmount ? item?.businessContractPriceTaxAmount : 0);
              console.log(
                item?.businessContractPriceWithTax,
                item.businessContractPriceTaxAmount,
                '哈哈哈',
                item.businessContractPricePureAmount
              );
              // item.businessContractPricePureAmount = '';
              // item.businessVariablePrice = query.businessChangeUnitPrice || ''; // 业务结算价
              // item.businessVariablePriceWithoutTax = query.businessContractUnitPrice || ''; // 业务结算价不含税单价
              // item.storageNo = this.storageInstructionDetail[0].storageNo
              // item.storageName = this.storageInstructionDetail[0].storageName
              // item.businessVariablePriceWithTax = query.businessContractUnitPrice; // 业务结算价含税金额
              // item.businessVariablePricePureAmount =
              //   query.businessContractTotalAmount * query.financeContractTaxAmount; // 业务结算价净值
              // item.businessVariablePriceTaxAmount =
              //   item.businessVariablePriceWithTax - item.businessVariablePricePureAmount; // 业务结算价税额
              // item.businessContractPriceWithTax =
              //   query.productQuantity * query.businessContractUnitPrice; // 合同价含税金额
              // item.businessContractPricePureAmount =
              //   query.businessContractTotalAmount * query.financeContractTaxAmount; // 合同价净值
              // item.businessContractPriceTaxAmount = query.financeContractPureAmount;  // 合同价税额
              // item.taxRate = query.taxRate;
            });
            //发货指令类型
            this.instructionTypeChange(this.formInline.instructionType);
            // 赋值关联供应商发货指令的业务公司等
            this.formBaseInfo.relatedInstructionCompanyName = '城矿公司'; // 只能是城矿公司  固定写死
            // this.formBaseInfo.relatedInstructionPartnerName =
            //   data.instructionCompanyName || data.companyName;
            (this.customerExtraData = {
              companyCode: this.formInline.instructionCompanyNo,
            }),
              // 设置获取客户详情参数
              (this.addrExtraData = {
                partnerCode: this.formBaseInfo.customerNo,
                departmentCode: this.formBaseInfo.instructionDepartmentNo,
              });
            this.getRelateCompanyList(data.companyCode, data.companyName);
            this.formBaseInfo.inboundDate = new Date();
          } else {
            this.loading.endLoading();
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },

      getContractList(code) {
        if (!code) return;
        let params = {
          // 查询关联合同 用公司名称
          // contractBusinessCompanyNo: code,
          companyName: code,
          contractStatus: 'ZT03',
          dataGroup: 'zjmi',
          groupByContractDetailNoFlag: '1',
          contractCategory: 'purchase',
        };
        this.$axios.post(API.LIST_ORDER_API, params).then((res) => {
          if (res.data.code == 0) {
            const contract = [];
            let list = res.data.data || [];
            list.map((item, index) => {
              contract.push({
                label: item.contractNo || '',
                index,
                value: item.id,
                supplierName: item.supplierName,
              });
            });
            this.contractList = contract;
          }
        });
      },

      //获取剩余数量
      getRemainNumber() {
        console.log(this.storageInstructionDetail);
        let params = {
          purchaseContractNo: this.formBaseInfo.purchaseContractNo,
          purchaseIntentNo: this.formBaseInfo.purchaseIntentNo,
          storageInstructionDetail: JSON.stringify(this.storageInstructionDetail),
        };
        console.log(this.storageInstructionDetail);
        this.$axios.post(API.GET_REMAINNUMBER_API, params).then((res) => {
          if (0 == res.data.code) {
            this.storageInstructionDetail.map((item) => {
              res.data.data.map((item2) => {
                if (
                  item.purchaseContractDetailNo &&
                  item.purchaseContractDetailNo == item2.purchaseContractDetailNo
                ) {
                  item.instructionAbleNumber = item2.instructionNumber;
                }
                // if (
                //   item.purchaseIntentDetailNo &&
                //   item.purchaseIntentDetailNo == item2.purchaseIntentDetailNo
                // ) {
                //   item.instructionAbleNumber = item2.instructionNumber;
                // }
                // if (isDetails) {
                //   //如果是详情调用
                //   // item.instructionAbleNumber = item.instructionAbleNumber;
                // } else {
                //   // if(item.overShippedPercentage){
                //   //   //发货指令数量不含溢装比例
                //   //   item.instructionNumber = this.$cal.calCommon(item.instructionAbleNumber,this.$cal.calCommon(item.productQuantity,this.$cal.calCommon(item.overShippedPercentage,100,'/'),'*'),'-','quantity') >= 0 ?this.$cal.calCommon(item.instructionAbleNumber,this.$cal.calCommon(item.productQuantity,this.$cal.calCommon(item.overShippedPercentage,100,'/'),'*'),'-','quantity'):0;
                //   // }else{
                //   item.instructionNumber = item.instructionAbleNumber;
                //   // }
                // }
                this.$refs.goodsTable.reloadRow(item);
              });
            });
            this.$refs.goodsTable.updateStatus();
            this.loading.endLoading();
          }
        });
      },

      //获取详情
      getDetail(api) {
        this.loading.startLoading();
        console.log(api + this.instructionNo, '--->>');
        this.showTable = false;
        this.$axios
          .get(api + this.instructionNo)
          .then((res) => {
            if (0 == res.data.code) {
              this.dataGroupHN = res.data.data.dataGroup == 'hn';
              this.showTable = true;
              console.log(res.data.data, '222222222234552');
              // 根据公司编号查合同
              // this.getContractList(res.data.data.companyCode);
              this.getContractList('广西物产城矿发展有限公司');
              // 详情时 由接口获取
              // this.getRelateCompanyList(res.data.data.companyCode, res.data.data.companyName);
              this.showStatus = res.data.data.instructionStatus;
              this.getBaseNameList(res.data.data.purchaseContractNo || '0300184');
              //forminline信息赋值
              const {
                id,
                version,
                tenantCode,
                companyNo,
                companyName,
                instructionCompanyNo, //供应商发货指令公司
                instructionCompanyName, //供应商发货指令公司
                departmentCode,
                departmentName,
                instructionNo,
                instructionStatus,
                instructionCreatePersonName,
                instructionType,
                directDeliver,
                deliverMethod,
                instructionCreateDate,
                projectInitiationNo,
                projectName,
              } = res.data.data;
              console.log(JSON.stringify(res.data.data));
              this.formInline = {
                id,
                version,
                tenantCode,
                companyNo,
                companyName,
                instructionCompanyNo, //供应商发货指令公司
                instructionCompanyName, //供应商发货指令公司
                departmentCode,
                departmentName,
                instructionNo,
                instructionStatus,
                instructionCreatePersonName,
                instructionType,
                directDeliver,
                deliverMethod,
                instructionCreateDate,
                projectInitiationNo,
                projectName,
                // 复制时 不赋值这个值
                businessInboundNo:
                  this.judgeType == 3
                    ? ''
                    : res.data.data.storageInstructionDetails[0].businessInboundNo || '',
              };
              //forminBase信息赋值
              const {
                partnerNo,
                partnerName,
                customerName,
                customerNo,
                instructionDepartmentNo,
                instructionDepartmentName,
                salesmanNo,
                salesmanName,
                deliverFromAddress,
                deliverToStorageNo,
                deliverToStorageName,
                purchaseIntentNo,
                deliverDate,
                inboundDate,
                platformCompanyCode,
                platformCompanyName,
                baseName,
                expectArrivalDate,
                // flowDirection,
                // registrationNo,
                insured,
                externalContractNo,
                shippingContact,
                businessMode,
                // distributionMode,
                deliverFromStorageNo,
                deliverFromStorageName,
                shippingContactPerson,
                // marineLadingNo,
                // warehouseReceiptsNo,
                purchaseContractNo,
                shippingMark,
                currencyTypeCode,
                contractDetailCategory,
                deliverToAddress,
                isRelatedOtherInstruction,
                relatedInstructionNo,
                relatedInstructionCompanyName,
                relatedInstructionPurchaseContractNo,
                relatedInstructionPartnerName,
              } = res.data.data;
              this.formBaseInfo = {
                partnerNo,
                partnerName,
                customerName,
                customerNo,
                instructionDepartmentNo,
                instructionDepartmentName,
                salesmanNo,
                salesmanName,
                deliverFromAddress,
                deliverToStorageNo,
                deliverToStorageName,
                purchaseIntentNo,
                deliverDate,
                inboundDate,
                platformCompanyCode,
                platformCompanyName,
                baseName,
                expectArrivalDate,
                // flowDirection,
                // registrationNo,
                insured,
                externalContractNo,
                shippingContact,
                businessMode,
                // distributionMode,
                deliverFromStorageNo,
                deliverFromStorageName,
                shippingContactPerson,
                // marineLadingNo,
                // warehouseReceiptsNo,
                purchaseContractNo,
                shippingMark,
                currencyTypeCode,
                contractDetailCategory,
                deliverToAddress,
                isRelatedOtherInstruction: isRelatedOtherInstruction === 'Y' ? true : false,
                // 复制时 无关联供应商发货指令号
                relatedInstructionNo: this.judgeType == 3 ? '' : relatedInstructionNo,
                relatedInstructionCompanyName,
                relatedInstructionPurchaseContractNo,
                relatedInstructionPartnerName,
                projectInitiationNo,
                projectName,
              };
              // 复制获取详情时 删除入库批次号 业务入库单号
              const storageInstructionDetails = res.data.data.storageInstructionDetails || [];
              this.formBaseInfo.shipingMethod = storageInstructionDetails[0].shipingMethod;
              if (storageInstructionDetails && this.judgeType == 3) {
                storageInstructionDetails.forEach((item) => {
                  if (item.businessInboundBatchNo) {
                    delete item.businessInboundBatchNo;
                  }
                  if (item.businessInboundNo) {
                    delete item.businessInboundNo;
                  }
                });
              }
              //三个列表信息赋值
              this.storageAttachment = res.data.data.storageAttachments || [];
              console.log(this.storageAttachment, '===获取数据===');
              this.storageInstructionTransport = res.data.data.storageInstructionTransports;
              this.storageInstructionDetail = storageInstructionDetails.map((item) => {
                return {
                  ...item,
                  productNo: item?.productDetailCode ? item.productDetailCode : item.productNo,
                  businessContractPricePureAmount:
                    (item?.businessContractPriceWithTax ? item?.businessContractPriceWithTax : 0) -
                    (item?.businessContractPriceTaxAmount
                      ? item?.businessContractPriceTaxAmount
                      : 0),
                };
              });
              this.getRemainNumber(true); //获取详情时更新instructionAbleNumber可发货数量
              this.$refs.formInline.clearValidate();
              (this.customerExtraData = {
                companyCode: this.formInline.instructionCompanyNo,
              }),
                // 设置获取客户详情参数
                (this.addrExtraData = {
                  partnerCode: this.formBaseInfo.customerNo,
                  departmentCode: this.formBaseInfo.instructionDepartmentNo,
                });
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .finally(() => this.loading.endLoading());
      },
      //转换
      transferSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //发货指令类型的变更
      instructionTypeChange(val) {
        if (val == 'ZL01') {
          //非直拨-供应商配送
          this.formInline.directDeliver = '0';
          this.formInline.deliverMethod = '0'; //此处原来绑定的0
        } else if (val == 'ZL02') {
          //非直拨-物产自提
          this.formInline.directDeliver = '0';
          this.formInline.deliverMethod = '1';
        } else if (val == 'ZL03') {
          //非直拨-库转
          this.formInline.directDeliver = '0';
          this.formInline.deliverMethod = '3';
        } else if (val == 'ZL04') {
          //直拨-供应商配送
          this.formInline.directDeliver = '1';
          this.formInline.deliverMethod = '0';
        } else if (val == 'ZL05') {
          //直拨-客户自提
          this.formInline.directDeliver = '1';
          this.formInline.deliverMethod = '2';
        } else if (val == 'ZL06') {
          //直拨-物产自提
          this.formInline.directDeliver = '1';
          this.formInline.deliverMethod = '1';
        } else if (val == 'ZL07') {
          //直拨-委托加工
          this.formInline.directDeliver = '1';
          this.formInline.deliverMethod = '1';
        }
        // if (this.formInline.directDeliver == '1') {
        //   this.formBaseInfo.flowDirection = '';
        // }
        // if (this.formInline.directDeliver == '0') {
        //   this.extraData.isDirectDeliver = "0"
        // } else {
        //   this.extraData.isDirectDeliver = '1'
        // 直拨 物流批次禁用
        // this.storageInstructionDetail.forEach(item=>{
        //   item.distributionBatchNo=''
        //  })
        // }
        if (this.formBaseInfo.deliverToStorageNo) {
          this.checkWareHouse();
        }
      },
      checkWareHouse() {
        this.$axios
          .get(`${API.CHECK_WAREHOUSE_BELONG_API}${this.formBaseInfo.deliverToStorageNo}`)
          .then((res) => {
            if (res.data.code == 0) {
              this.isDirectDeliverFlag = res.data.data.isDirectDeliver;
              // if (this.isDirectDeliverFlag == null || (this.isDirectDeliverFlag != this.formInline.directDeliver)) {
              //   this.chooseForm(null, "deliverToStorageNo")
              // }
            }
          });
      },
      //运输方式变更
      distributionModeChange(val) {
        console.log(val);
      },
      //新增
      insertEvent() {
        let record = {
          nameVoyageLicense: '',
          freightInformation: '',
          contactPerson: '',
          contactPhoneNo: '',
          identityCardNumber: '',
          distributionBatchNo: '',
        };
        this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
      },
      removeGoodsTable() {
        let selectRecords = this.$refs.goodsTable.getCheckboxRecords();
        console.log(this.$refs.goodsTable.getTableData().fullData);
        if (this.$refs.goodsTable.getTableData().fullData.length > 1) {
          if (selectRecords.length < 1) {
            this.$message({
              showClose: true,
              message: this.$t('xTable.noSelectData'),
              type: 'error',
            });
            return;
          } else if (
            selectRecords.length === this.$refs.goodsTable.getTableData().fullData.length
          ) {
            this.$message({
              showClose: true,
              message: this.$t('不能删除全部数据！'),
              type: 'error',
            });
            return;
          } else {
            this.$confirmAction()
              .then(() => {
                this.$message({
                  showClose: true,
                  type: 'success',
                  message: this.$t('receivablesManage.message.deleteSuccess'),
                });
                this.$refs.goodsTable.removeSelecteds();
              })
              .catch(() => {
                /* this.$message({
              showClose: true,
              type: "info",
              message: this.$t('receivablesManage.message.cancelled')
            }); */
              });
          }
        } else {
          this.$message({
            showClose: true,
            message: this.$t('当前仅剩一条数据不可删除！'),
            type: 'error',
          });
          return;
        }
      },
      //合并
      // rowspanMethod({ column, rowIndex }) {
      //   if (this.needMergeArr.includes(column.property)) {
      //     return this.mergeAction('productDesc', rowIndex, column);
      //   }
      //   if (this.needMergeArr.includes(column.property)) {
      //     return this.mergeAction('leftInboundQuantity', rowIndex, column);
      //   }
      // },
      // mergeAction(val, rowIndex) {
      //   let _row = this.rowMergeArrs[val].rowArr[rowIndex] || '';
      //   let _col = _row > 0 ? 1 : 0;
      //   return {
      //     rowspan: _row,
      //     colspan: _col,
      //   };
      // },
      // 复制所选行
      // handleCopy() {
      //   const selectedList = this.$refs['goodsTable'].getCheckboxRecords(); // 选中数据
      //   if (selectedList.length < 1) {
      //     this.$message({
      //       showClose: true,
      //       message: this.$t('xTable.noSelectData'),
      //       type: 'error',
      //     });
      //     return;
      //   }
      //   // 将相同供应商行号的放在相邻的行
      //   this.loopArray(selectedList, 0, selectedList.length);
      //   this.merge();
      //   // this.rowSpan();
      // },
      // loopArray(selectedList, x, length) {
      //   while (x < length) {
      //     this.insertGoodsEvent(selectedList[x]);
      //     x++;
      //   }
      // },
      // insertGoodsEvent(row) {
      //   const record = Object.assign(
      //     {},
      //     {
      //       purchaseContractDetailNo: '',
      //       businessInboundNo: '',
      //       businessInboundBatchNo: '',
      //       productNo: '',
      //       productDesc: '',
      //       instructionAbleNumber: '',
      //       instructionNumber: '',
      //       overShippedPercentage: '',
      //       unit: '',
      //       packaging: '',
      //       unitWeight: '',
      //       unitNumber: '',
      //       packagingNumber: '',
      //       packagingUnit: '',
      //       storageName: '',
      //       mark: '',
      //       contractUnitPrice: '',
      //       totalAmount: '',
      //       businessVariablePrice: '',
      //       businessVariablePriceWithoutTax: '',
      //       businessVariablePriceWithTax: '',
      //       businessContractPriceWithTax: '',
      //       businessContractPricePureAmount: '',
      //       businessContractPriceTaxAmount: '',
      //       taxRate: '',
      //       businessVariablePricePureAmount: '',
      //       businessVariablePriceTaxAmount: '',
      //     },
      //     row
      //   );
      //   const _xid = record._XID;
      //   delete record._XID;
      //   const index = this.storageInstructionDetail.findIndex((item) => {
      //     return item._XID == _xid;
      //   });
      //   this.storageInstructionDetail.splice(index, 0, record);
      // },
      // 计算合并列：相邻的行项目号
      // merge() {
      //   const length = this.storageInstructionDetail.length;
      //   this.purchaseContractDetailNo = [];
      //   let samePos = 0;
      //   for (let i = 0; i < length; i++) {
      //     if (i === 0) {
      //       this.purchaseContractDetailNo.push(1);
      //       samePos = 0;
      //     } else {
      //       if (
      //         this.storageInstructionDetail[i].purchaseContractDetailNo ===
      //         this.storageInstructionDetail[i - 1].purchaseContractDetailNo
      //       ) {
      //         this.purchaseContractDetailNo[samePos] += 1;
      //         this.purchaseContractDetailNo.push(0);
      //       } else {
      //         this.purchaseContractDetailNo.push(1);
      //         samePos = i;
      //       }
      //     }
      //   }
      // },
      // rowSpan() {
      //   this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, this.storageInstructionDetail);
      // },
      // rowMergeHandle(arr, data) {
      //   if (!Array.isArray(arr) && !arr.length) return false;
      //   if (!Array.isArray(data) && !data.length) return false;
      //   let needMerge = {};
      //   arr.forEach((i) => {
      //     needMerge[i] = {
      //       rowArr: [],
      //       rowMergeNum: 0,
      //     };
      //     data.forEach((item, index) => {
      //       if (index === 0) {
      //         needMerge[i].rowArr.push(1);
      //         needMerge[i].rowMergeNum = 0;
      //       } else {
      //         if (
      //           item[i] === data[index - 1][i] &&
      //           item['purchaseContractDetailNo'] === data[index - 1].purchaseContractDetailNo
      //         ) {
      //           needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
      //           needMerge[i].rowArr.push(0);
      //         } else {
      //           needMerge[i].rowArr.push(1);
      //           needMerge[i].rowMergeNum = index;
      //         }
      //       }
      //     });
      //   });
      //   return needMerge;
      // },
      //删除
      remove() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$alert('请至少选择一条数据！');
        }
      },
      //上传
      upload() {
        this.$refs.uploadDialog.openDialog(true, this.formInline.instructionNo, this.isShowBtn);
      },
      //1提交物流 2生成业务入库单 3生成委托加工单 需校验必填
      checkSave(val) {
        console.log('checkSave');
        console.log(this.formInline, '????');
        if (this.formInline.instructionCompanyNo == '') {
          return this.$message({
            showClose: true, //flowDirectionMessage
            message: this.$t('请核查合同单据业务公司是否填写！'),
            type: 'error',
          });
        }
        // let formArr = ['formInline', 'formBaseInfo', 'xTable', 'goodsTable']; //两个表单/一个表格
        let formArr = ['formInline', 'formBaseInfo', 'goodsTable']; //两个表单/一个表格
        var resultArr = []; //用来接受返回结果的数组
        var _self = this;
        // if(this.formInline.instructionType == 'ZL01' || this.formInline.instructionType == 'ZL06'){
        //   if(this.$refs.xTable.getTableData().fullData.length == 0){
        //     this.$message({
        //       showClose: true,
        //       message: this.$t("addSupplierDelivery.detail.addShippingInformation"),
        //       type: "error"
        //     })
        //     return
        //   }
        // }
        function checkForm(formName) {
          //封装验证表单的函数
          var result = new Promise(function (resolve, reject) {
            _self.$refs[formName].validate((valid) => {
              if (valid) {
                resolve();
              } else {
                reject();
              }
            });
          });
          resultArr.push(result); //push 得到promise的结果
        }
        formArr.forEach((item) => {
          //根据表单的ref校验
          checkForm(item);
        });
        Promise.all(resultArr)
          .then(function () {
            //都通过了
            _self.save(val);
          })
          .catch(function () {
            // console.log("err");
          });
      },
      //发货指令保存/提交物流/生成业务入库单
      save(val) {
        // 流向flowDirection 已不存在
        // if (val != 0) {
        //   if (
        //     (this.formBaseInfo.flowDirection == '' ||
        //       this.formBaseInfo.flowDirection == undefined) &&
        //     (this.formBaseInfo.deliverToStorageNo == '' ||
        //       this.formBaseInfo.deliverToStorageNo == undefined)
        //   ) {
        //     return this.$message({
        //       showClose: true, //flowDirectionMessage
        //       message: this.$t('addSupplierDelivery.rules.flowDirectionMessage'),
        //       type: 'error',
        //     });
        //   }
        // }
        this.storageAttachment = this.$refs.fileTableRef.getTableData();
        this.storageInstructionDetail = this.$refs.goodsTable.getTableData().fullData;
        // this.storageInstructionTransport = this.$refs.xTable.getTableData().fullData;
        console.log(this.$route.query?.isRestrict, '---->>>');
        if (this.$route.query?.isRestrict == '1') {
          if (val != 0) {
            if (
              !this.storageInstructionDetail.find((item) =>
                item.instructionNumber ? Number(item.instructionNumber) > 0 : ''
              )
            ) {
              return this.$message({
                showClose: true,
                message: this.$t('addSupplierDelivery.rules.noInstructionNumber'),
                type: 'error',
              });
            }
          }
        }
        // 提交生效都不用传商品行信息的id
        if (this.storageInstructionDetail && val == 1) {
          this.storageInstructionDetail.forEach((item) => {
            if (item.id) {
              delete item.id;
            }
          });
        }
        // 已撤回状态下 再次提交生效 商品行信息加业务入库单号
        if (this.showStatus == 3 && val == 1 && this.storageInstructionDetail) {
          this.storageInstructionDetail.forEach((item) => {
            item.businessInboundNo = this.formInline.businessInboundNo;
          });
        }
        // 已复制 附件若无值传空数组
        if (this.judgeType == 3 && !this.storageAttachment) {
          this.storageAttachment = [];
        }

        let obj = {};
        console.log(this.formBaseInfo, '--------->>>');
        obj = Object.assign(
          obj,

          this.formInline,
          {
            storageInstructionDetail: JSON.stringify(this.storageInstructionDetail),
          },
          // {
          //   storageInstructionTransport: JSON.stringify(this.storageInstructionTransport),
          // },
          {
            storageAttachment: JSON.stringify(this.storageAttachment),
          },
          this.formBaseInfo,
          // 撤销状态 保存传3 提交生效传1
          { instructionStatus: val == 1 ? val : this.showStatus == 3 ? 3 : 0 }
        );
        // 已复制 businessInboundNo version 不需要
        if (this.judgeType == 3) {
          if (obj.businessInboundNo) {
            delete obj.businessInboundNo;
          }
          if (obj.version) {
            delete obj.version;
          }
        }
        obj.isRelatedOtherInstruction = obj.isRelatedOtherInstruction ? 'Y' : 'N';
        // 不传 versioN
        delete obj.version;
        // 保存时
        // if (val === 0) {
        //   delete obj.isRelatedOtherInstruction;
        //   delete obj.relatedInstructionNo;
        //   delete obj.relatedInstructionCompanyName;
        //   delete obj.relatedInstructionPurchaseContractNo;
        //   delete obj.relatedInstructionPartnerName;
        // }
        // 提交参数 提交且能勾选并且勾选自动 // 撤销状态下 不传relatedInstruction 商品行信息加业务入库单号
        if (val == 1 && !this.relativeCheckFlag && this.formBaseInfo.isRelatedOtherInstruction) {
          if (this.showStatus != 3) {
            // 非撤回状态 提交
            let submitObj = XEUtils.clone(obj, true);
            delete submitObj.isRelatedOtherInstruction;
            delete submitObj.relatedInstructionNo;
            delete submitObj.relatedInstructionCompanyName;
            delete submitObj.relatedInstructionPurchaseContractNo;
            delete submitObj.relatedInstructionPartnerName;
            delete submitObj.id;
            delete submitObj.instructionNo;
            // 小对象里的采购合同号为关联采购合同号
            submitObj.purchaseContractNo = obj.relatedInstructionPurchaseContractNo;
            // delete submitObj.version;
            obj.relatedInstruction = submitObj;
          }
        }
        // 已关联并是撤回状态下保存或提交
        if (this.formBaseInfo.isRelatedOtherInstruction && this.showStatus === '3') {
          this.$confirm(
            `请同时修改已关联的供应商发货指令${this.formBaseInfo.relatedInstructionNo}!`,
            '警告',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
          ).then(() => {
            this.loading.startLoading();
            this.$axios
              .post(API.SAVE_DATA_API, { ...obj, businessGroup: this.userInfo.businessGroup })
              .then((res) => {
                if (0 == res.data.code) {
                  this.$message({
                    showClose: true,
                    message: '操作成功',
                    type: 'success',
                  });
                  this.returnPath();
                  // if (val == '2') {
                  //   //生成业务入库
                  //   this.goToOtherMoudle(res.data.data);
                  // } else if (val == '3') {
                  //   this.goToMcInbound(res.data.data);
                  // } else if (val == 0) {
                  //   this.dblclickEvent(res.data.data);
                  //   this.judge();
                  // } else {
                  //   this.returnPath();
                  // }
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              })
              .finally(() => this.loading.endLoading());
          });
        } else {
          this.loading.startLoading();
          this.$axios
            .post(API.SAVE_DATA_API, { ...obj, businessGroup: this.userInfo.businessGroup })
            .then((res) => {
              if (0 == res.data.code) {
                this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: 'success',
                });
                this.returnPath();
                // if (val == '2') {
                //   //生成业务入库
                //   this.goToOtherMoudle(res.data.data);
                // } else if (val == '3') {
                //   this.goToMcInbound(res.data.data);
                // } else if (val == 0) {
                //   this.dblclickEvent(res.data.data);
                //   this.judge();
                // } else {
                //   this.returnPath();
                // }
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            })
            .finally(() => this.loading.endLoading());
        }
      },
      // sxp add 20210120 创建付款申请
      addPaymentApply() {
        const selectedList = this.$refs.goodsTable.getSelectRecords(); // 获取选中数据
        if (selectedList.length == 0) {
          return this.$message({ showClose: true, message: '请至少选择一条数据！', type: 'error' });
        }
        let params = { storageInstructionDetail: JSON.stringify(selectedList) };
        [
          'id',
          'version',
          'tenantCode',
          'companyCode',
          'companyName',
          'departmentCode',
          'instructionCompanyNo',
          'instructionCompanyName',
          'departmentName',
          'instructionNo',
        ].map((item) => {
          params[item] = this.formInline[item];
        });
        let path = {
          path: '/payment/paymentApplyAdd',
          name: 'paymentApplyAdd',
          meta: {
            keepAlive: true,
            title: '付款申请单创建',
          },
          query: {
            isEdit: 'Y',
            enterName: 'SUPPLIERDELIVERY', // 入口名称
            params: JSON.stringify(params),
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/wareHouse/addSupplierDelivery',
            name: 'addSupplierDelivery',
            meta: {
              keepAlive: true,
              title: '创建供应商发货指令',
            },
          },
          toPath: {
            path: '/wareHouse/addSupplierDelivery',
            name: 'addSupplierDelivery',
            meta: {
              keepAlive: true,
              title: '供应商发货指令维护',
            },
            query: { instructionNo: value.instructionNo, type: 2, flag: 2 },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //选择关联合同号-临时
      setReferenceContract(prop, val) {
        const contractList = [];
        val.map((item) => {
          contractList.push(item.contractNo);
        });
        this.formBaseInfo.referenceContractNo = contractList.join(',');
      },
      // 返回列表页
      returnPath() {
        let path = {
          fromPath: {
            path: '/wareHouse/addSupplierDelivery',
            name: 'addSupplierDelivery',
            meta: {
              keepAlive: true,
              title: '创建供应商发货指令',
            },
          },
          toPath: {
            path: '/wareHouse/supplierDeliveryOrder',
            name: 'supplierDeliveryOrder',
            meta: {
              keepAlive: false,
              title: '供应商发货指令',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 跳转委托加工单
      goToMcInbound(val) {
        let path = {
          fromPath: {
            path: '/wareHouse/addSupplierDelivery',
            name: 'addSupplierDelivery',
            meta: {
              keepAlive: true,
              title: '创建供应商发货指令',
            },
          },
          toPath: {
            path: '/wareHouse/mcInboundAdd',
            name: 'mcInboundAdd',
            meta: {
              keepAlive: false,
              title: '新增委托加工入库单',
            },
            query: {
              instructionNo: val.instructionNo,
              instructionDetailNo: val.instructionDetailNo || '1',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //跳转生成业务入库
      goToOtherMoudle(val) {
        let contractDetailNoList = this.$route.query.contractDetailNoList || [];
        if (this.$route.query.contractDetailNoList) {
          if (!XEUtils.isArray(contractDetailNoList))
            contractDetailNoList = contractDetailNoList.split(',');
        } else if (val.storageInstructionDetails.length > -1) {
          val.storageInstructionDetails.map((item) => {
            let contractDetailNo = item.purchaseContractDetailNo || item.purchaseIntentDetailNo;
            contractDetailNoList.push(contractDetailNo);
          });
        }
        let path = {
          fromPath: {
            path: '/wareHouse/addSupplierDelivery',
            name: 'addSupplierDelivery',
            meta: {
              keepAlive: true,
              title: '创建供应商发货指令',
            },
          },
          toPath: {
            path: '/logistics/businessReceiptAdd',
            name: 'businessReceiptAdd',
            meta: {
              keepAlive: false,
              title: '业务入库',
            },
            query: {
              shipNo: val.instructionNo,
              contractNo: val.purchaseContractNo || val.purchaseIntentNo,
              contractDetailNoList: contractDetailNoList,
              sourceType: '1',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //撤销
      withdraw() {
        let obj = {
          instructionNo: this.formInline.instructionNo,
          version: this.formInline.version,
        };
        if (this.formBaseInfo.isRelatedOtherInstruction) {
          this.$confirm(
            `同时撤回关联供应商发货指令号${this.formBaseInfo.relatedInstructionNo}!`,
            '警告',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
          ).then(() => {
            this.loading.startLoading();
            this.$axios
              .post(API.BACK_OUT_API, { ...obj, businessGroup: this.userInfo.businessGroup })
              .then((res) => {
                if (0 == res.data.code) {
                  this.$message({
                    showClose: true,
                    message: '操作成功',
                    type: 'success',
                  });
                  this.returnPath();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              })
              .finally(() => this.loading.endLoading());
          });
        } else {
          this.loading.startLoading();
          this.$axios
            .post(API.BACK_OUT_API, { ...obj, businessGroup: this.userInfo.businessGroup })
            .then((res) => {
              if (0 == res.data.code) {
                this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: 'success',
                });
                this.returnPath();
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            })
            .finally(() => this.loading.endLoading());
        }
      },
      //删除
      delte() {
        let obj = {
          id: this.formInline.id,
          instructionNo: this.formInline.instructionNo,
          version: this.formInline.version,
        };
        if (this.formBaseInfo.isRelatedOtherInstruction && this.showStatus === '3') {
          this.$confirm(
            `同时删除关联供应商发货指令号${this.formBaseInfo.relatedInstructionNo}!`,
            '警告',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
          ).then(() => {
            this.loading.startLoading();
            this.$axios
              .post(API.DEL_DATA_API, obj)
              .then((res) => {
                if (0 == res.data.code) {
                  this.$message({
                    showClose: true,
                    message: '操作成功',
                    type: 'success',
                  });
                  this.returnPath();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              })
              .finally(() => this.loading.endLoading());
          });
        } else {
          this.loading.startLoading();
          this.$axios
            .post(API.DEL_DATA_API, obj)
            .then((res) => {
              if (0 == res.data.code) {
                this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: 'success',
                });
                this.returnPath();
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            })
            .finally(() => this.loading.endLoading());
        }
      },
      //申请运输
      // applayTransfer() {
      //   if (this.formInline.deliverMethod != '1') {
      //     //不是物产自提
      //     this.$message({
      //       showClose: true,
      //       message: '只有发货方式为物产自提可以提交运输信息至物流',
      //       type: 'error',
      //     });
      //     return;
      //   }
      //   this.storageInstructionDetail = this.$refs.goodsTable.getTableData().fullData;
      //   // this.storageInstructionTransport = this.$refs.xTable.getTableData().fullData;
      //   let obj = {};
      //   obj = Object.assign(
      //     obj,
      //     this.formBaseInfo,
      //     this.formInline,
      //     {
      //       storageInstructionDetail: JSON.stringify(this.storageInstructionDetail),
      //     },
      //     // {
      //     //   storageInstructionTransport: JSON.stringify(this.storageInstructionTransport),
      //     // },
      //     {
      //       storageAttachment: JSON.stringify(this.storageAttachment),
      //     }
      //   );
      //   // const { tenantCode, companyCode, departmentCode, companyName, departmentName, instructionCreatePersonName } = this.formInline;
      //   // let obj = {
      //   //   instructionNo: this.formInline.instructionNo,
      //   //   version: this.formInline.version,
      //   //   instructionCreatePersonNo: this.userInfo.userCode,
      //   //   tenantCode, companyCode, departmentCode, companyName, departmentName, instructionCreatePersonName
      //   // };
      //   this.loading.startLoading();
      //   this.$axios
      //     .post(API.SAVE_TRANSPORT_API, obj)
      //     .then((res) => {
      //       if (0 == res.data.code) {
      //         this.$message({
      //           showClose: true,
      //           message: '操作成功',
      //           type: 'success',
      //         });
      //         this.returnPath();
      //       } else {
      //         this.$message({
      //           showClose: true,
      //           message: res.data.msg,
      //           type: 'error',
      //         });
      //       }
      //     })
      //     .finally(() => this.loading.endLoading());
      // },
      //更新附件列表
      // uploadList(value) {
      //   this.storageAttachment = [];
      //   if (value.length) {
      //     value.map((item, index) => {
      //       this.storageAttachment.push({
      //         ...item,
      //         sortNo: index,
      //       });
      //     });
      //   }
      // },
    },
  };
</script>
<style lang="scss" scoped>
  .addSupplierDelivery .topFrom {
    padding: 26px 20px 8px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 17px 0px rgba(72, 89, 102, 0.16);
    border-radius: 3px;
    margin-bottom: 10px;
  }
  .addSupplierDelivery .inputWidth {
    width: 100% !important;
  }
</style>
